// src/locales/tr/admin.ts
var admin = {
  nav: {
    groups: {
      overview: "Genel",
      operations: "Operasyon",
      sales: "Sat\u0131\u015F & CRM",
      finance: "Finans",
      content: "\u0130\xE7erik",
      system: "Sistem"
    },
    dashboard: "G\xF6sterge paneli",
    bookings: "Rezervasyonlar",
    calendar: "Takvim",
    fleet: "Filo & ilanlar",
    categories: "Kategoriler",
    pricing: "Fiyat & kampanya",
    services: "Hizmet talepleri",
    serviceCatalog: "Hizmet katalo\u011Fu",
    tripPlans: "Seyahat planlar\u0131",
    workOrders: "\u0130\u015F emirleri",
    staff: "Personel",
    customers: "M\xFC\u015Fteriler",
    privacy: "KVKK talepleri",
    leads: "Talepler",
    finance: "Finans",
    cms: "\u0130\xE7erik y\xF6netimi",
    reviews: "Yorumlar",
    notifications: "Bildirim \u015Fablonlar\u0131",
    reports: "Raporlar",
    settings: "Ayarlar",
    users: "Kullan\u0131c\u0131lar & roller",
    audit: "Denetim kayd\u0131"
  },
  topbar: {
    search: "Ara\u2026",
    profile: "Profilim"
  },
  search: {
    placeholder: "Rezervasyon kodu, m\xFC\u015Fteri, e-posta veya ilan ara\u2026",
    hint: "Aramak i\xE7in en az 2 karakter yaz\u0131n.",
    empty: "Sonu\xE7 bulunamad\u0131.",
    failed: "Arama yap\u0131lamad\u0131. L\xFCtfen tekrar deneyin.",
    keys: "\u2191 \u2193 ile gezinin, Enter ile a\xE7\u0131n, Esc ile kapat\u0131n.",
    groups: {
      booking: "Rezervasyonlar",
      serviceRequest: "Hizmet talepleri",
      customer: "M\xFC\u015Fteriler",
      asset: "\u0130lanlar"
    }
  },
  dashboard: {
    greeting: "Ho\u015F geldiniz, {{name}}",
    systemStatus: "Sistem durumu",
    database: "Veritaban\u0131",
    redis: "Redis",
    up: "\xC7al\u0131\u015F\u0131yor",
    down: "Eri\u015Filemiyor",
    yourAccess: "Eri\u015Fiminiz",
    roles: "Rolleriniz",
    permissionsCount: "Tan\u0131ml\u0131 izin: {{count}}",
    superAdmin: "T\xFCm mod\xFCllere tam eri\u015Fim"
  },
  placeholder: {
    phase: "Faz {{phase}}",
    title: "Bu mod\xFCl yak\u0131nda",
    description: "{{module}} mod\xFCl\xFC yol haritas\u0131nda {{phase}} kapsam\u0131nda geli\u015Ftirilecek."
  },
  roles: {
    SUPER_ADMIN: "S\xFCper Admin",
    OPERATIONS_MANAGER: "Operasyon M\xFCd\xFCr\xFC",
    RESERVATION_AGENT: "Rezervasyon Sorumlusu",
    FINANCE: "Finans",
    CONTENT_EDITOR: "\u0130\xE7erik Edit\xF6r\xFC",
    SUPPORT: "Destek",
    TECHNICAL_SERVICE: "Teknik Servis"
  },
  common: {
    all: "T\xFCm\xFC",
    none: "\u2014",
    unsaved: "Kaydedilmemi\u015F de\u011Fi\u015Fiklikler var",
    search: "Ara\u2026",
    translations: "\xC7eviriler",
    loadFailed: "Veriler y\xFCklenemedi."
  },
  assetStatus: { DRAFT: "Taslak", PUBLISHED: "Yay\u0131nda", ARCHIVED: "Ar\u015Fivde" },
  bookingStatus: {
    DRAFT: "Taslak",
    PENDING_PAYMENT: "\xD6deme bekliyor",
    AWAITING_CONFIRMATION: "Onay bekliyor",
    CONFIRMED: "Onayland\u0131",
    IN_PROGRESS: "Devam ediyor",
    COMPLETED: "Tamamland\u0131",
    CANCELLED: "\u0130ptal edildi",
    REFUNDED: "\u0130ade edildi",
    NO_SHOW: "Gelmedi"
  },
  fleet: {
    roomOf: "Oda tipi \xB7 {{hotel}}",
    title: "Filo & ilanlar",
    subtitle: "Yat, jet, ara\xE7 ve transfer filosunu tek yerden y\xF6netin.",
    new: "Yeni ilan",
    search: "Ad, kod veya URL ara",
    category: "Kategori",
    status: "Durum",
    sort: { UPDATED: "Son g\xFCncellenen", NAME: "Ada g\xF6re", CODE: "Koda g\xF6re" },
    columns: {
      listing: "\u0130lan",
      category: "Kategori",
      status: "Durum",
      location: "Konum",
      capacity: "Kapasite",
      price: "Ba\u015Flayan fiyat",
      updated: "G\xFCncellendi"
    },
    media: "Medya: {{count}}",
    featured: "\xD6ne \xE7\u0131kan",
    empty: "Bu kriterlere uygun ilan yok."
  },
  asset: {
    rooms: {
      title: "Oda tipleri",
      note: "Otel, oda tipleri \xFCzerinden sat\u0131l\u0131r; fiyat, ekstra ve m\xFCsaitlik oda tiplerindedir.",
      empty: "Hen\xFCz oda tipi yok. Oteli yay\u0131nlamak i\xE7in en az bir oda tipi ekleyin.",
      count: "{{count}} oda",
      add: "Oda tipi ekle"
    },
    sale: {
      title: "Sat\u0131\u015F bilgileri",
      note: "Sat\u0131l\u0131k ilanlarda kiralama fiyat\u0131 ve takvim yoktur; ilan talep ve \xF6zel g\xF6sterim \xFCzerinden sat\u0131l\u0131r.",
      price: "Sat\u0131\u015F fiyat\u0131",
      priceHint: "Fiyat gizlense de dahili kay\u0131t i\xE7in girilebilir.",
      status: "Sat\u0131\u015F durumu",
      statuses: {
        AVAILABLE: "Sat\u0131\u015Fta",
        UNDER_OFFER: "Teklif a\u015Famas\u0131nda",
        SOLD: "Sat\u0131ld\u0131"
      },
      priceOnRequest: 'Sitede "Fiyat talep \xFCzerine" g\xF6ster',
      soldAt: "Sat\u0131\u015F tarihi: {{date}}"
    },
    newTitle: "Yeni ilan",
    back: "Filoya d\xF6n",
    tabs: {
      general: "Genel",
      content: "\u0130\xE7erik",
      attributes: "\xD6zellikler",
      media: "Medya",
      pricing: "Fiyat & kurallar",
      extras: "Ekstralar & politika",
      availability: "M\xFCsaitlik",
      seo: "SEO"
    },
    fields: {
      category: "Kategori",
      code: "\u0130lan kodu",
      codeHint: "\xD6rn. YAT-009",
      name: "Ad",
      slug: "URL",
      slugHint: "Sitedeki adres: /{{category}}/{{slug}}",
      ownership: "Sahiplik",
      homeLocation: "Ba\u011Fl\u0131 oldu\u011Fu konum",
      capacity: "Kapasite",
      capacityHint: "Misafir, yolcu veya koltuk say\u0131s\u0131",
      parent: "\xDCst otel",
      parentHint: "Oda tipi ise ait oldu\u011Fu oteli se\xE7in; otelin kendisi i\xE7in bo\u015F b\u0131rak\u0131n.",
      parentNone: "Yok \u2014 bu bir otel",
      inventoryUnits: "Oda say\u0131s\u0131",
      inventoryUnitsHint: "Bu tipteki \xF6zde\u015F oda say\u0131s\u0131; ayn\u0131 gece en fazla bu kadar rezervasyon kabul edilir.",
      sessionTimes: "Seans saatleri",
      sessionTimesHint: "Planl\u0131 deneyimler i\xE7in sabit ba\u015Flang\u0131\xE7 saatleri, virg\xFClle (\xF6r. 05:30, 17:00). Bo\u015F b\u0131rak\u0131l\u0131rsa seans yoktur.",
      sessionMinutes: "Seans s\xFCresi (dakika)",
      featured: "Ana sayfada \xF6ne \xE7\u0131kar",
      featuredOrder: "\xD6ne \xE7\u0131kma s\u0131ras\u0131",
      headline: "K\u0131sa ba\u015Fl\u0131k",
      description: "A\xE7\u0131klama",
      currency: "Para birimi",
      rates: "Baz fiyatlar",
      rateUnit: "Birim",
      rateAmount: "Tutar",
      minDuration: "Minimum s\xFCre",
      addRate: "Fiyat ekle",
      deposit: "Kapora oran\u0131 (%)",
      depositHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa kategori varsay\u0131lan\u0131 kullan\u0131l\u0131r (%{{percent}}).",
      minNotice: "Minimum bildirim (saat)",
      bufferBefore: "\xD6ncesi tampon (dk)",
      bufferAfter: "Sonras\u0131 tampon (dk)",
      buffersHint: "Temizlik, yak\u0131t ve yer de\u011Fi\u015Ftirme i\xE7in rezervasyonlar aras\u0131nda b\u0131rak\u0131lan s\xFCre.",
      amenities: "Donan\u0131mlar",
      addOns: "Ekstralar",
      priceOverride: "\xD6zel fiyat",
      included: "Fiyata dahil",
      policy: "\u0130ptal politikas\u0131",
      seoTitle: "SEO ba\u015Fl\u0131\u011F\u0131",
      seoDescription: "SEO a\xE7\u0131klamas\u0131",
      noIndex: "Arama motorlar\u0131nda gizle"
    },
    ownership: { COMPANY_OWNED: "\u015Eirket filosu", MANAGED: "Y\xF6netilen (sahip ad\u0131na)" },
    pricingNote: "Sezon, hafta sonu, \xF6zel g\xFCn ve saat dilimi kurallar\u0131 ile sezon tarifeleri \xABFiyat & kampanya\xBB ekran\u0131ndan y\xF6netilir.",
    pricingLink: "Fiyat & kampanya",
    routePricingNote: "Bu kategoride fiyatlar rota bazl\u0131d\u0131r; \xFCcretler \xABFiyat & kampanya \u2192 Rota \xFCcretleri\xBB ekran\u0131ndan y\xF6netilir.",
    selectCategory: "\xD6nce kategori se\xE7in.",
    noAttributes: "Bu kategori i\xE7in tan\u0131ml\u0131 \xF6zellik yok.",
    saveFirst: "Medya ve m\xFCsaitlik i\xE7in \xF6nce ilan\u0131 kaydedin.",
    actions: {
      create: "\u0130lan\u0131 olu\u015Ftur",
      save: "Kaydet",
      publish: "Yay\u0131nla",
      unpublish: "Yay\u0131ndan kald\u0131r",
      archive: "Ar\u015Fivle",
      restore: "Tasla\u011Fa geri al",
      view: "Sitede g\xF6r"
    },
    toasts: {
      created: "\u0130lan olu\u015Fturuldu.",
      saved: "De\u011Fi\u015Fiklikler kaydedildi.",
      published: "\u0130lan yay\u0131nda.",
      unpublished: "\u0130lan tasla\u011Fa al\u0131nd\u0131.",
      archived: "\u0130lan ar\u015Fivlendi.",
      restored: "\u0130lan tasla\u011Fa geri al\u0131nd\u0131."
    },
    publishIssues: "Yay\u0131nlamadan \xF6nce tamamlay\u0131n:"
  },
  media: {
    drop: "Foto\u011Fraf veya videolar\u0131 s\xFCr\xFCkleyip b\u0131rak\u0131n ya da se\xE7in",
    hint: "JPEG, PNG, WebP, AVIF (en fazla {{image}} MB) \xB7 MP4, WebM (en fazla {{video}} MB)",
    uploading: "Y\xFCkleniyor: {{name}}",
    uploaded: "Medya y\xFCklendi.",
    cover: "Kapak",
    setCover: "Kapak yap",
    representative: "Yapay zek\xE2 \xB7 yay\u0131n \xF6ncesi ger\xE7ek foto\u011Frafla de\u011Fi\u015Ftirin",
    alt: "Alternatif metin",
    caption: "A\xE7\u0131klama",
    remove: "Kald\u0131r",
    removeConfirm: "Bu medya ilandan kald\u0131r\u0131ls\u0131n m\u0131?",
    reorder: "S\u0131ralamak i\xE7in s\xFCr\xFCkleyin",
    reordered: "S\u0131ralama kaydedildi.",
    empty: "Hen\xFCz medya yok.",
    video: "Video",
    details: "Detaylar"
  },
  availability: {
    title: "M\xFCsaitlik takvimi",
    add: "Takvimi kapat",
    reason: "Neden",
    reasons: {
      MAINTENANCE: "Bak\u0131m",
      OWNER_USE: "Sahip kullan\u0131m\u0131",
      MANUAL: "Manuel kapatma",
      WEATHER: "Hava ko\u015Fullar\u0131",
      OTHER: "Di\u011Fer"
    },
    start: "Ba\u015Flang\u0131\xE7",
    end: "Biti\u015F",
    note: "Not",
    blocks: "Kapat\u0131lan d\xF6nemler",
    bookings: "Rezervasyonlar",
    noBlocks: "Kapat\u0131lm\u0131\u015F d\xF6nem yok.",
    noBookings: "Bu d\xF6nemde rezervasyon yok.",
    added: "Takvim kapat\u0131ld\u0131.",
    removed: "Kapatma kald\u0131r\u0131ld\u0131.",
    legend: { available: "M\xFCsait", partial: "K\u0131smen dolu", unavailable: "Dolu" }
  },
  categories: {
    listingTypes: { RENTAL: "Kiral\u0131k", SALE: "Sat\u0131l\u0131k" },
    listingTypeLocked: "Kategoride ilan oldu\u011Fu i\xE7in ilan t\xFCr\xFC de\u011Fi\u015Ftirilemez.",
    unitAttributes: {
      title: "Oda tipi alanlar\u0131",
      hint: "Oda tiplerinin \xF6zellikleri (m\xB2, yatak, manzara\u2026). Otelin kendi alanlar\u0131 yukar\u0131dad\u0131r."
    },
    behaviour: {
      viewingModes: "Sunulan g\xF6sterim t\xFCrleri",
      title: "Davran\u0131\u015F",
      hint: "Kategorinin sitede nas\u0131l davrand\u0131\u011F\u0131n\u0131 belirler; rezervasyon modundan ba\u011F\u0131ms\u0131zd\u0131r.",
      navGroup: "Men\xFC grubu",
      capacityNoun: "Kapasite ifadesi",
      leadKind: "Talep t\xFCr\xFC",
      charterEstimate: "U\xE7u\u015F s\xFCresi ve fiyat aral\u0131\u011F\u0131 tahmini",
      charterClasses: "Sonu\xE7lar\u0131 s\u0131n\u0131flara g\xF6re grupla",
      emptyLegs: "Bo\u015F bacak u\xE7u\u015Flar\u0131n\u0131n kayna\u011F\u0131",
      roomTypes: "Oda tipleriyle sat\u0131\u015F (otel)",
      plannerRole: "Seyahat planlay\u0131c\u0131daki rol\xFC",
      plannerNone: "Planlay\u0131c\u0131da yer almaz",
      navGroups: {
        TRAVEL: "Seyahat",
        STAY: "Konaklama",
        EXPERIENCE: "Deneyim",
        ACQUIRE: "Sat\u0131l\u0131k"
      },
      capacityNouns: {
        GUESTS: "Misafir",
        PASSENGERS: "Yolcu",
        SEATS: "Koltuk",
        ROOMS: "Oda",
        BEDROOMS: "Yatak odas\u0131"
      },
      leadKinds: {
        SALE_INQUIRY: "Sat\u0131\u015F bilgisi talebi",
        BOOKING_REQUEST: "Rezervasyon talebi",
        CHARTER_REQUEST: "Charter talebi"
      }
    },
    title: "Kategoriler",
    subtitle: "Dinamik kategori motoru: \xF6zellik \u015Femas\u0131, arama formu, fiyat modeli ve rezervasyon modu kod yazmadan y\xF6netilir.",
    new: "Yeni kategori",
    assets: "\u0130lan: {{count}}",
    inactive: "Pasif",
    back: "Kategorilere d\xF6n",
    tabs: { general: "Genel", attributes: "\xD6zellik \u015Femas\u0131", search: "Arama formu" },
    fields: {
      listingType: "\u0130lan t\xFCr\xFC",
      key: "Anahtar",
      keyHint: "Kodda ve raporlarda kullan\u0131l\u0131r; sonradan de\u011Fi\u015Ftirilemez.",
      slug: "URL",
      name: "Ad",
      description: "A\xE7\u0131klama",
      icon: "\u0130kon",
      pricingModel: "Fiyat modeli",
      bookingMode: "Rezervasyon modu",
      durationUnits: "S\xFCre birimleri",
      deposit: "Varsay\u0131lan kapora (%)",
      manifest: "Yolcu manifestosu zorunlu",
      active: "Sitede aktif",
      sortOrder: "S\u0131ra"
    },
    pricingModels: { TIME_BASED: "S\xFCre bazl\u0131", ROUTE_BASED: "Rota bazl\u0131", QUOTE: "Teklif usul\xFC" },
    bookingModes: { INSTANT: "An\u0131nda rezervasyon", REQUEST: "Onayl\u0131 talep", QUOTE: "Teklif" },
    field: {
      add: "Alan ekle",
      key: "Anahtar",
      type: "Tip",
      label: "Etiket",
      unit: "Birim",
      group: "Grup",
      required: "Zorunlu",
      filterable: "Filtrelenebilir",
      showOnCard: "Kartta g\xF6ster",
      min: "Min",
      max: "Maks",
      options: "Se\xE7enekler",
      addOption: "Se\xE7enek ekle",
      value: "De\u011Fer",
      remove: "Alan\u0131 kald\u0131r",
      moveUp: "Yukar\u0131 ta\u015F\u0131",
      moveDown: "A\u015Fa\u011F\u0131 ta\u015F\u0131",
      placeholder: "Yer tutucu",
      locationTypes: "Konum tipleri",
      locationMatch: "Konum e\u015Fle\u015Fmesi",
      durationUnits: "S\xFCre birimleri",
      attribute: "Ba\u011Fl\u0131 \xF6zellik",
      attributeWhenOff: "Kapal\u0131yken ba\u011Fl\u0131 \xF6zellik",
      roundTrip: "A\xE7\u0131kken gidi\u015F\u2013d\xF6n\xFC\u015F",
      span: "Geni\u015Flik (1\u201312)",
      none: "Yok",
      empty: "Hen\xFCz alan yok."
    },
    attributeTypes: {
      TEXT: "Metin",
      TEXTAREA: "Uzun metin",
      NUMBER: "Say\u0131",
      INTEGER: "Tam say\u0131",
      BOOLEAN: "Evet / hay\u0131r",
      SELECT: "Tek se\xE7im",
      MULTI_SELECT: "\xC7oklu se\xE7im",
      DATE: "Tarih",
      YEAR: "Y\u0131l"
    },
    searchTypes: {
      LOCATION: "Konum",
      ORIGIN: "Nereden",
      DESTINATION: "Nereye",
      ADDRESS: "Adres",
      DATE: "Tarih",
      DATE_RANGE: "Tarih aral\u0131\u011F\u0131",
      DATETIME: "Tarih ve saat",
      DATETIME_RANGE: "Tarih-saat aral\u0131\u011F\u0131",
      DURATION: "S\xFCre",
      GUESTS: "Misafir",
      ROOMS: "Oda say\u0131s\u0131",
      PASSENGERS: "Yolcu",
      LUGGAGE: "Bavul",
      TRIP_TYPE: "Yolculuk tipi",
      TOGGLE: "A\xE7\u0131k / kapal\u0131",
      SELECT: "Se\xE7im"
    },
    locationMatches: {
      EXACT_OR_DESCENDANT: "Se\xE7ilen yer ve i\xE7indekiler",
      SAME_REGION: "Ayn\u0131 \u015Fehir / b\xF6lge",
      NONE: "Filtreleme yok (g\xFCzerg\xE2h)"
    },
    created: "Kategori olu\u015Fturuldu.",
    saved: "Kategori kaydedildi.",
    invalidAssets: "{{count}} ilan yeni \u015Femaya uymuyor; yay\u0131nlamadan \xF6nce g\xFCncellenmeli."
  },
  leads: {
    viewingModes: {
      IN_PERSON: "Yerinde",
      VIDEO: "Video g\xF6r\xFC\u015Fme",
      SEA_TRIAL: "Deneme seyri",
      TEST_FLIGHT: "Test u\xE7u\u015Fu",
      TEST_DRIVE: "Test s\xFCr\xFC\u015F\xFC"
    },
    title: "Talepler",
    subtitle: "Web sitesinden gelen rezervasyon, charter ve geri arama talepleri.",
    search: "Ad, e-posta, telefon veya ilan ara",
    columns: {
      contact: "Ki\u015Fi",
      source: "Kaynak",
      interest: "\u0130lgi",
      status: "Durum",
      assignee: "Sorumlu",
      followUp: "Takip",
      created: "Tarih"
    },
    sources: {
      SALE_INQUIRY: "Sat\u0131\u015F bilgisi talebi",
      VIEWING_REQUEST: "\xD6zel g\xF6sterim talebi",
      CONTACT_FORM: "\u0130leti\u015Fim formu",
      CALLBACK_REQUEST: "Geri arama",
      BOOKING_REQUEST: "Rezervasyon talebi",
      CHARTER_REQUEST: "Charter teklifi",
      WHATSAPP: "WhatsApp",
      PHONE: "Telefon",
      EMAIL: "E-posta",
      INSTAGRAM: "Instagram",
      REFERRAL: "Referans",
      WALK_IN: "Ofis ziyareti",
      OTHER: "Di\u011Fer"
    },
    statuses: {
      NEW: "Yeni",
      CONTACTED: "\u0130leti\u015Fime ge\xE7ildi",
      QUALIFIED: "Nitelikli",
      PROPOSAL: "Teklif a\u015Famas\u0131nda",
      CONVERTED: "D\xF6n\xFC\u015Ft\xFC",
      LOST: "Kaybedildi"
    },
    assigneeFilter: { me: "Bana atananlar", none: "Atanmam\u0131\u015F" },
    detail: {
      viewing: "G\xF6sterim tercihi",
      title: "Talep detay\u0131",
      message: "Mesaj",
      search: "Arama kriterleri",
      addOns: "Se\xE7ilen ekstralar",
      channel: "Tercih edilen kanal",
      notes: "\u0130\xE7 notlar",
      assignee: "Sorumlu dan\u0131\u015Fman",
      unassigned: "Atanmam\u0131\u015F",
      followUp: "Takip tarihi",
      listing: "\u0130lan",
      saved: "Talep g\xFCncellendi."
    },
    empty: "Hen\xFCz talep yok."
  },
  bookings: {
    title: "Rezervasyonlar",
    subtitle: "Web ve operasyon rezervasyonlar\u0131; \xF6deme, durum ve iptal talepleri tek ekranda.",
    search: "Kod, misafir, e-posta veya ilan ara",
    filters: {
      status: "Durum",
      category: "Kategori",
      from: "Ba\u015Flang\u0131\xE7 (en erken)",
      to: "Ba\u015Flang\u0131\xE7 (en ge\xE7)",
      cancellationRequested: "Yaln\u0131zca iptal talepleri"
    },
    sort: {
      START_ASC: "Yakla\u015Fan \xF6nce",
      START_DESC: "\u0130leri tarih \xF6nce",
      CREATED_DESC: "Yeni olu\u015Fturulan"
    },
    columns: {
      code: "Kod",
      customer: "Misafir",
      listing: "\u0130lan",
      period: "Tarih",
      status: "Durum",
      total: "Tutar",
      created: "Olu\u015Fturma"
    },
    empty: "Bu kriterlere uygun rezervasyon yok.",
    cancellationRequested: "\u0130ptal talebi",
    back: "Rezervasyonlara d\xF6n",
    modes: { INSTANT: "An\u0131nda", REQUEST: "Onayl\u0131 talep", QUOTE: "Teklif" },
    sources: {
      WEB: "Web",
      ADMIN: "Panel",
      PHONE: "Telefon",
      WHATSAPP: "WhatsApp",
      EMAIL: "E-posta",
      WALK_IN: "Ofis",
      MOBILE_APP: "Mobil uygulama",
      PARTNER: "Partner"
    },
    detail: {
      summary: "\xD6zet",
      period: "Tarih",
      place: "Konum / g\xFCzerg\xE2h",
      guests: "Ki\u015Fi",
      mode: "Mod",
      source: "Kaynak",
      coupon: "Kupon",
      customer: "M\xFC\u015Fteri hesab\u0131",
      guestCheckout: "\xDCyeliksiz rezervasyon",
      contact: "\u0130leti\u015Fim",
      travellers: "Yolcular",
      special: "\xD6zel istekler",
      price: "Fiyat d\xF6k\xFCm\xFC",
      paid: "\xD6denen",
      balance: "Kalan",
      balanceDue: "Son \xF6deme: {{date}}",
      payments: "\xD6demeler",
      noPayments: "\xD6deme yok.",
      history: "Durum ge\xE7mi\u015Fi",
      system: "Sistem",
      notes: "\u0130\xE7 notlar",
      notePlaceholder: "Ekiple payla\u015F\u0131lacak not\u2026",
      addNote: "Not ekle",
      pin: "Notu sabitle",
      pinned: "Sabitlenmi\u015F",
      noNotes: "Hen\xFCz not yok.",
      noteAdded: "Not eklendi.",
      cancellationRequest: "M\xFC\u015Fteri {{date}} tarihinde iptal talep etti.",
      reason: "Neden: {{reason}}",
      refundEstimate: "Politikaya g\xF6re iade tahmini: {{amount}} (%{{percent}})",
      refundNote: "Tahsil edilmi\u015F bir \xF6deme yoksa iade yap\u0131lmaz. Al\u0131nan \xF6demelerin iadesini \xABpayments.refund\xBB yetkisi olan bir kullan\u0131c\u0131 yapar.",
      hold: "\xD6deme bekleniyor; tarih {{time}} saatine kadar tutuluyor.",
      testPayments: "Test \xF6deme sa\u011Flay\u0131c\u0131s\u0131 aktif (ger\xE7ek tahsilat yok).",
      viewOnSite: "M\xFC\u015Fteri sayfas\u0131"
    },
    actions: {
      CONFIRMED: "Onayla",
      IN_PROGRESS: "Ba\u015Flad\u0131",
      COMPLETED: "Tamamland\u0131",
      NO_SHOW: "Gelmedi",
      CANCELLED: "\u0130ptal et"
    },
    confirm: {
      reason: "A\xE7\u0131klama (iste\u011Fe ba\u011Fl\u0131)",
      CONFIRMED: "Rezervasyon onaylanacak; \xF6n provizyon varsa tahsil edilecek ve m\xFC\u015Fteriye onay e-postas\u0131 gidecek.",
      IN_PROGRESS: "Hizmet ba\u015Flad\u0131 olarak i\u015Faretlenecek.",
      COMPLETED: "Rezervasyon tamamland\u0131 olarak kapat\u0131lacak.",
      NO_SHOW: "M\xFC\u015Fteri gelmedi olarak i\u015Faretlenecek.",
      CANCELLED: "Rezervasyon iptal edilecek, \xF6n provizyonlar serbest b\u0131rak\u0131lacak ve m\xFC\u015Fteriye e-posta g\xF6nderilecek.",
      submit: "Onayla"
    },
    transitioned: "Durum g\xFCncellendi.",
    reasons: {
      CHECKOUT: "Web checkout",
      PAYMENT_AUTHORIZED: "\xD6n provizyon al\u0131nd\u0131",
      PAYMENT_RECEIVED: "\xD6deme al\u0131nd\u0131",
      PAYMENT_CAPTURED: "\xD6n provizyon tahsil edildi",
      HOLD_EXPIRED: "\xD6deme s\xFCresi doldu",
      AUTO: "Otomatik",
      MANUAL: "Manuel",
      CUSTOMER_CANCELLED: "M\xFC\u015Fteri iptal etti",
      INVENTORY_CONFLICT: "Takvim \xE7ak\u0131\u015Fmas\u0131",
      REFUND: "\u0130ade yap\u0131ld\u0131"
    },
    finance: {
      collect: "Tahsilat ekle",
      collectHint: "Havale/EFT, nakit veya POS ile al\u0131nan \xF6demeyi kaydedin. \xD6deme ad\u0131m\u0131ndaki rezervasyon bu i\u015Flemle onaylan\u0131r.",
      kind: "\xD6deme t\xFCr\xFC",
      method: "Y\xF6ntem",
      amount: "Tutar ({{currency}})",
      outstanding: "Kalan: {{amount}}",
      account: "Hesap",
      paidAt: "\xD6deme zaman\u0131",
      reference: "Dekont / slip no",
      note: "Not",
      collected: "Tahsilat kaydedildi.",
      refund: "\u0130ade yap",
      refundHint: "Kart \xF6demeleri sa\u011Flay\u0131c\u0131ya iade edilir; havale/nakit iadesini se\xE7ti\u011Finiz hesaptan siz \xF6dersiniz.",
      refundable: "\u0130ade edilebilir: {{amount}}",
      refundAmount: "\u0130ade tutar\u0131 ({{currency}})",
      refundAccount: "Havale/nakit iadesi hesab\u0131",
      refundAccountDefault: "\xD6demenin al\u0131nd\u0131\u011F\u0131 hesap",
      refunded: "\u0130ade i\u015Flendi.",
      refundFailed: "Sa\u011Flay\u0131c\u0131 iadeyi reddetti; yeniden deneyebilirsiniz.",
      refunds: "\u0130adeler",
      retry: "Yeniden dene",
      paymentLink: "\xD6deme ba\u011Flant\u0131s\u0131 g\xF6nder",
      paymentLinkHint: "M\xFC\u015Fteriye rezervasyon sayfas\u0131n\u0131n g\xFCvenli ba\u011Flant\u0131s\u0131 e-postayla gider; kalan {{amount}} 3D Secure ile \xF6denir.",
      message: "Mesaj (iste\u011Fe ba\u011Fl\u0131)",
      linkSent: "\xD6deme ba\u011Flant\u0131s\u0131 g\xF6nderildi.",
      invoices: "Faturalar",
      createInvoice: "Fatura olu\u015Ftur",
      noInvoices: "Hen\xFCz fatura yok.",
      invoiceCreated: "Fatura tasla\u011F\u0131 olu\u015Fturuldu.",
      cancelRefund: "\u015Eimdi iade edilecek tutar ({{currency}})",
      cancelRefundHint: "Politika tahmini \xF6nerildi; 0 girerseniz iade yap\u0131lmaz, sonra da yap\u0131labilir.",
      failure: "Hata: {{reason}}"
    },
    manual: {
      new: "Yeni rezervasyon",
      title: "Yeni rezervasyon",
      subtitle: "Telefon, WhatsApp, e-posta veya ofisten gelen rezervasyonlar; fiyat motoru ve m\xFCsaitlik kontrol\xFCyle.",
      customer: "M\xFC\u015Fteri",
      source: "Kanal",
      locale: "E-posta dili",
      discount: "\xD6zel indirim (KDV hari\xE7, {{currency}})",
      discountHint: "Kararla\u015Ft\u0131r\u0131lan indirim; KDV indirimli tutar \xFCzerinden hesaplan\u0131r.",
      discountReason: "\u0130ndirim gerek\xE7esi",
      paymentWindow: "\xD6deme s\xFCresi",
      hours: "{{count}} saat",
      sendLink: "\xD6deme linkini m\xFC\u015Fteriye e-postayla g\xF6nder",
      note: "\u0130\xE7 not",
      calculate: "Fiyat\u0131 hesapla",
      create: "Rezervasyonu olu\u015Ftur",
      created: "Rezervasyon {{code}} olu\u015Fturuldu.",
      hint: "Minimum bildirim s\xFCresi uygulanmaz; m\xFCsaitlik ve \xE7ak\u0131\u015Fma kontrol\xFC yap\u0131l\u0131r. \xD6deme s\xFCresi doldu\u011Funda \xF6denmemi\u015F rezervasyon iptal edilir.",
      back: "Rezervasyonlara d\xF6n"
    }
  },
  pricing: {
    title: "Fiyat & kampanya",
    subtitle: "Sezon tarifeleri, hafta sonu, \xF6zel g\xFCn ve saat dilimi kurallar\u0131, rota \xFCcretleri, kuponlar, ekstralar ve iptal politikalar\u0131.",
    tabs: {
      seasons: "Sezonlar",
      rules: "Fiyat kurallar\u0131",
      fares: "Rota \xFCcretleri",
      coupons: "Kuponlar",
      addOns: "Ekstralar",
      policies: "\u0130ptal politikalar\u0131",
      simulator: "Sim\xFClat\xF6r"
    },
    common: {
      new: "Yeni",
      edit: "D\xFCzenle",
      delete: "Sil",
      deleteConfirm: "Bu kay\u0131t silinsin mi?",
      saved: "Kaydedildi.",
      deleted: "Silindi.",
      active: "Aktif",
      inactive: "Pasif",
      category: "Kategori",
      asset: "\u0130lan",
      scope: "Kapsam",
      allCategories: "T\xFCm kategoriler",
      currency: "Para birimi",
      unit: "S\xFCre birimi",
      anyUnit: "T\xFCm birimler",
      priority: "\xD6ncelik",
      priorityHint: "Ayn\u0131 t\xFCrde birden \xE7ok kural uyarsa ilana \xF6zel kural, sonra y\xFCksek \xF6ncelik kazan\u0131r.",
      validFrom: "Ba\u015Flang\u0131\xE7 tarihi",
      validTo: "Biti\u015F tarihi",
      empty: "Hen\xFCz kay\u0131t yok.",
      readOnly: "G\xF6r\xFCnt\xFCleme yetkiniz var; de\u011Fi\u015Fiklik i\xE7in fiyat y\xF6netimi yetkisi gerekir."
    },
    seasons: {
      name: "Sezon ad\u0131",
      start: "Ba\u015Flang\u0131\xE7",
      end: "Biti\u015F",
      recurs: "Her y\u0131l tekrarla",
      recursHint: "Yaln\u0131zca g\xFCn ve ay dikkate al\u0131n\u0131r; y\u0131lba\u015F\u0131n\u0131 a\u015Fabilir.",
      color: "Renk",
      rates: "Sezon tarifeleri",
      addRate: "Tarife ekle",
      mode: "T\xFCr",
      modes: { MULTIPLIER: "Baz fiyat \xE7arpan\u0131", AMOUNT: "Sabit birim fiyat" },
      multiplier: "\xC7arpan (%)",
      multiplierHint: "125 = baz fiyat +%25",
      amount: "Birim fiyat",
      minDuration: "Sezonda minimum s\xFCre",
      yearly: "Her y\u0131l",
      once: "Tek seferlik"
    },
    rules: {
      name: "Kural ad\u0131",
      kind: "Kural t\xFCr\xFC",
      kinds: {
        WEEKEND: "Hafta sonu",
        SPECIAL_DAY: "\xD6zel g\xFCn",
        TIME_OF_DAY: "Saat dilimi",
        DURATION_DISCOUNT: "Uzun s\xFCre indirimi",
        ROUTE_FARE: "Rota \xFCcreti",
        EXTRA_GUEST: "Ek misafir"
      },
      adjustment: "Ayarlama",
      adjustments: { PERCENT: "Y\xFCzde", AMOUNT: "Tutar (\xB1)", FIXED_PRICE: "Sabit fiyat" },
      percent: "Y\xFCzde",
      percentHint: "Negatif de\u011Fer indirimdir (\xF6rn. -10).",
      amount: "Tutar",
      days: "G\xFCnler",
      conditions: "Ko\u015Fullar",
      daysHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa hafta sonu kural\u0131 Cumartesi\u2013Pazar, di\u011Ferleri her g\xFCn ge\xE7erli.",
      startTime: "Ba\u015Flang\u0131\xE7 saati",
      endTime: "Biti\u015F saati",
      minDuration: "Minimum s\xFCre",
      maxDuration: "Maksimum s\xFCre",
      includedGuests: "Dahil misafir say\u0131s\u0131",
      includedGuestsHint: "Bu say\u0131n\u0131n \xFCzerindeki her misafir, her birim (gece, seans\u2026) i\xE7in kural tutar\u0131n\u0131 \xF6der."
    },
    weekdays: { d1: "Pzt", d2: "Sal", d3: "\xC7ar", d4: "Per", d5: "Cum", d6: "Cmt", d7: "Paz" },
    fares: {
      route: "G\xFCzerg\xE2h",
      condition: "Ara\xE7 s\u0131n\u0131f\u0131",
      anyCondition: "T\xFCm s\u0131n\u0131flar",
      onlyAsset: "Yaln\u0131zca bu ara\xE7",
      anyAsset: "T\xFCm ara\xE7lar",
      amount: "Bacak ba\u015F\u0131 \xFCcret"
    },
    coupons: {
      code: "Kod",
      description: "A\xE7\u0131klama",
      type: "\u0130ndirim t\xFCr\xFC",
      types: { PERCENT: "Y\xFCzde", FIXED_AMOUNT: "Sabit tutar" },
      percent: "\u0130ndirim (%)",
      amount: "\u0130ndirim tutar\u0131",
      maxDiscount: "En fazla indirim",
      minOrder: "En az sepet tutar\u0131",
      usageLimit: "Toplam kullan\u0131m limiti",
      perUser: "M\xFC\u015Fteri ba\u015F\u0131na limit",
      used: "Kullan\u0131m",
      validity: "Ge\xE7erlilik",
      categories: "Ge\xE7erli kategoriler",
      categoriesHint: "Se\xE7im yap\u0131lmazsa t\xFCm kategorilerde ge\xE7erlidir.",
      statuses: {
        ACTIVE: "Aktif",
        SCHEDULED: "Planland\u0131",
        EXPIRED: "S\xFCresi doldu",
        INACTIVE: "Pasif"
      },
      inUse: "Kullan\u0131lm\u0131\u015F kuponlar silinemez; pasife al\u0131n."
    },
    addOns: {
      key: "Anahtar",
      name: "Ad",
      description: "A\xE7\u0131klama",
      pricingType: "Fiyatland\u0131rma",
      pricingTypes: {
        PER_BOOKING: "Rezervasyon ba\u015F\u0131na",
        PER_PERSON: "Ki\u015Fi ba\u015F\u0131",
        PER_HOUR: "Saat ba\u015F\u0131",
        PER_DAY: "G\xFCn ba\u015F\u0131",
        PER_UNIT: "Adet ba\u015F\u0131"
      },
      price: "Fiyat",
      tax: "KDV (%)",
      maxQuantity: "En fazla adet",
      leadTime: "Haz\u0131rl\u0131k s\xFCresi (saat)",
      sortOrder: "S\u0131ra",
      assets: "\u0130lan: {{count}}"
    },
    policies: {
      key: "Anahtar",
      name: "Ad",
      description: "A\xE7\u0131klama",
      tiers: "\u0130ade kademeleri",
      addTier: "Kademe ekle",
      hoursBefore: "Ba\u015Flang\u0131\xE7tan \xF6nce (saat)",
      refund: "\u0130ade (%)",
      isDefault: "Varsay\u0131lan politika",
      default: "Varsay\u0131lan",
      assets: "\u0130lan: {{count}}"
    },
    simulator: {
      hint: "Se\xE7ilen ilan i\xE7in m\xFCsaitlikten ba\u011F\u0131ms\u0131z, kurallar\u0131n uyguland\u0131\u011F\u0131 tam fiyat d\xF6k\xFCm\xFC.",
      asset: "\u0130lan",
      run: "Hesapla",
      pickAsset: "\xD6nce bir ilan se\xE7in."
    }
  },
  finance: {
    title: "Finans",
    subtitle: "Tahsilatlar, iadeler, giderler, kasa/banka hesaplar\u0131, faturalar ve raporlar tek yerde.",
    tabs: {
      overview: "\xD6zet",
      payments: "Tahsilat & iade",
      receivables: "Alacaklar",
      expenses: "Giderler",
      accounts: "Kasa & banka",
      invoices: "Faturalar",
      reports: "Raporlar",
      rates: "Kurlar"
    },
    testMode: "Test \xF6deme sa\u011Flay\u0131c\u0131s\u0131 aktif: kart \xF6demeleri sim\xFCle edilir ve \u201CTest sanal POS\u201D hesab\u0131na i\u015Flenir.",
    export: { label: "D\u0131\u015Fa aktar", xlsx: "Excel (.xlsx)", csv: "CSV", pdf: "PDF" },
    filters: {
      from: "Ba\u015Flang\u0131\xE7",
      to: "Biti\u015F",
      status: "Durum",
      search: "Ara\u2026",
      account: "Hesap",
      type: "T\xFCr",
      direction: "Y\xF6n",
      method: "Y\xF6ntem",
      provider: "Sa\u011Flay\u0131c\u0131",
      category: "Kategori",
      listing: "\u0130lan",
      overdueOnly: "Yaln\u0131zca vadesi ge\xE7enler"
    },
    common: {
      actions: "\u0130\u015Flemler",
      saved: "Kaydedildi.",
      empty: "Kay\u0131t yok.",
      reason: "A\xE7\u0131klama",
      amount: "Tutar",
      currency: "Para birimi",
      date: "Tarih",
      account: "Hesap",
      description: "A\xE7\u0131klama",
      booking: "Rezervasyon",
      listing: "\u0130lan",
      status: "Durum",
      total: "Toplam",
      confirm: "Onayla",
      readOnly: "G\xF6r\xFCnt\xFCleme yetkiniz var; de\u011Fi\u015Fiklik i\xE7in ilgili finans yetkisi gerekir.",
      openBooking: "Rezervasyonu a\xE7",
      by: "Kaydeden"
    },
    enums: {
      ledgerType: {
        PAYMENT: "Tahsilat",
        REFUND: "\u0130ade",
        EXPENSE: "Gider",
        TRANSFER: "Virman",
        ADJUSTMENT: "D\xFCzeltme",
        OPENING_BALANCE: "A\xE7\u0131l\u0131\u015F"
      },
      direction: { INFLOW: "Giri\u015F", OUTFLOW: "\xC7\u0131k\u0131\u015F" },
      method: {
        CARD: "Kart",
        BANK_TRANSFER: "Havale/EFT",
        CASH: "Nakit",
        POS: "POS",
        PAYMENT_LINK: "\xD6deme ba\u011Flant\u0131s\u0131"
      },
      provider: { IYZICO: "iyzico", STRIPE: "Stripe", MANUAL: "Manuel", TEST: "Test" },
      refundStatus: { PENDING: "\u0130\u015Fleniyor", SUCCEEDED: "\u0130ade edildi", FAILED: "Ba\u015Far\u0131s\u0131z" },
      expenseStatus: { PENDING: "\xD6denecek", PAID: "\xD6dendi", CANCELLED: "\u0130ptal" },
      invoiceStatus: {
        DRAFT: "Taslak",
        ISSUED: "Kesildi",
        SENT: "G\xF6nderildi",
        PAID: "\xD6dendi",
        PARTIALLY_PAID: "K\u0131smen \xF6dendi",
        CANCELLED: "\u0130ptal"
      },
      invoiceType: {
        SALES: "Sat\u0131\u015F faturas\u0131",
        PROFORMA: "Proforma",
        CREDIT_NOTE: "\u0130ade faturas\u0131"
      },
      accountType: {
        CASH: "Kasa",
        BANK: "Banka",
        POS: "POS cihaz\u0131",
        PAYMENT_PROVIDER: "Sanal POS"
      },
      rateSource: { TCMB: "TCMB", ECB: "ECB", MANUAL: "Manuel" },
      grouping: { DAY: "G\xFCnl\xFCk", WEEK: "Haftal\u0131k", MONTH: "Ayl\u0131k" },
      profitGrouping: { ASSET: "\u0130lan", CATEGORY: "Kategori", MONTH: "Ay" }
    },
    overview: {
      period: "Bu ay \xB7 {{from}} \u2013 {{to}}",
      collected: "Tahsilat",
      refunded: "\u0130ade",
      expenses: "Gider",
      net: "Net nakit",
      receivables: "A\xE7\u0131k alacak",
      overdue: "Vadesi ge\xE7en",
      overdueCount: "{{count}} rezervasyon",
      pendingRefunds: "Bekleyen iade",
      failedRefunds: "Ba\u015Far\u0131s\u0131z iade",
      draftInvoices: "Taslak fatura",
      accounts: "Hesap bakiyeleri",
      totalTry: "Toplam (TRY kar\u015F\u0131l\u0131\u011F\u0131)",
      trend: "Son 30 g\xFCn nakit ak\u0131\u015F\u0131",
      recent: "Son hareketler",
      viewLedger: "Hesap defteri"
    },
    payments: {
      collections: "Tahsilatlar",
      refunds: "\u0130adeler",
      code: "Kod",
      customer: "M\xFC\u015Fteri",
      kind: "T\xFCr",
      refundedPart: "\u0130ade: {{amount}}",
      retry: "Yeniden dene",
      retried: "\u0130ade yeniden denendi.",
      failure: "Hata: {{reason}}"
    },
    receivables: {
      subtitle: "Onayl\u0131 rezervasyonlar\u0131n kalan bakiyeleri; vadesi en yak\u0131n olan \xFCstte.",
      start: "Ba\u015Flang\u0131\xE7",
      paid: "\xD6denen",
      balance: "Kalan",
      due: "Vade",
      overdue: "{{days}} g\xFCn gecikti",
      noDue: "Vade yok",
      reminded: "Son hat\u0131rlatma: {{date}}",
      sendLink: "\xD6deme ba\u011Flant\u0131s\u0131 g\xF6nder",
      linkSent: "\xD6deme ba\u011Flant\u0131s\u0131 e-postayla g\xF6nderildi."
    },
    expenses: {
      new: "Yeni gider",
      edit: "Gideri d\xFCzenle",
      category: "Kategori",
      vendor: "Tedarik\xE7i",
      amount: "Tutar (KDV dahil)",
      vatRate: "KDV oran\u0131",
      vat: "KDV tutar\u0131",
      vatNone: "KDV yok",
      incurredAt: "Gider tarihi",
      paid: "\xD6dendi",
      paidAt: "\xD6deme zaman\u0131",
      account: "\xD6dendi\u011Fi hesap",
      listingNone: "Genel gider (ilana ba\u011Fl\u0131 de\u011Fil)",
      bookingCode: "Rezervasyon kodu (iste\u011Fe ba\u011Fl\u0131)",
      bookingNotFound: "Bu kodla rezervasyon bulunamad\u0131.",
      notes: "Notlar",
      receipt: "Fi\u015F / fatura",
      uploadReceipt: "Fi\u015F y\xFCkle",
      viewReceipt: "Fi\u015Fi a\xE7",
      receiptUploaded: "Fi\u015F y\xFCklendi.",
      cancel: "Gideri iptal et",
      cancelConfirm: "Gider iptal edilecek; \xF6dendiyse hesaba ters kay\u0131t d\xFC\u015F\xFClecek.",
      cancelled: "Gider iptal edildi.",
      categories: "Gider kategorileri",
      categoryNew: "Yeni kategori",
      categoryKey: "Anahtar",
      categoryName: "Ad",
      categoryCount: "{{count}} gider",
      overhead: "Genel gider"
    },
    accounts: {
      new: "Yeni hesap",
      edit: "Hesab\u0131 d\xFCzenle",
      name: "Hesap ad\u0131",
      type: "T\xFCr",
      provider: "Sa\u011Flay\u0131c\u0131",
      bankName: "Banka",
      iban: "IBAN",
      notes: "Notlar",
      active: "Aktif",
      inactive: "Pasif",
      opening: "A\xE7\u0131l\u0131\u015F bakiyesi",
      openingHint: "Yaln\u0131zca hesap olu\u015Fturulurken; defterde a\xE7\u0131l\u0131\u015F kayd\u0131 olarak g\xF6r\xFCn\xFCr.",
      lockedHint: "Hareket g\xF6ren hesab\u0131n t\xFCr\xFC ve para birimi de\u011Fi\u015Ftirilemez.",
      balance: "Bakiye",
      lastMovement: "Son hareket: {{date}}",
      noMovement: "Hen\xFCz hareket yok",
      transfer: "Virman",
      transferTitle: "Hesaplar aras\u0131 virman",
      from: "Kaynak hesap",
      to: "Hedef hesap",
      toAmount: "Hedef hesaba ge\xE7en tutar ({{currency}})",
      toAmountHint: "Para birimleri farkl\u0131ysa bankan\u0131n uygulad\u0131\u011F\u0131 kurla ge\xE7en tutar.",
      adjustment: "D\xFCzeltme kayd\u0131",
      adjustmentTitle: "Kasa/banka d\xFCzeltmesi",
      adjustmentHint: "Kasa say\u0131m fark\u0131, banka masraf\u0131 gibi belgesiz hareketler i\xE7in. Ters kay\u0131tla geri al\u0131nabilir.",
      direction: "Y\xF6n",
      ledger: "Hesap defteri",
      reverse: "Ters kay\u0131t",
      reverseTitle: "Ters kay\u0131t olu\u015Ftur",
      reverseHint: "Hareket silinmez; ayn\u0131 tutarda ters y\xF6nl\xFC bir kay\u0131t eklenir (virmanlarda iki bacak birlikte).",
      reversed: "Ters kay\u0131t eklendi.",
      reversedBadge: "Ters kayd\u0131 var",
      reversal: "Ters kay\u0131t",
      created: "Hesap olu\u015Fturuldu.",
      amountTry: "TRY kar\u015F\u0131l\u0131\u011F\u0131"
    },
    invoices: {
      new: "Yeni fatura",
      editor: "Fatura tasla\u011F\u0131",
      number: "Fatura no",
      draftNumber: "Numara kesimde verilir",
      type: "T\xFCr",
      billing: "Fatura bilgileri",
      billingName: "Ad / unvan",
      taxNumber: "VKN / TCKN",
      taxOffice: "Vergi dairesi",
      email: "E-posta",
      addressLine: "Adres",
      district: "\u0130l\xE7e",
      city: "\u015Eehir",
      postalCode: "Posta kodu",
      country: "\xDClke",
      lines: "Kalemler",
      addLine: "Kalem ekle",
      description: "A\xE7\u0131klama",
      quantity: "Miktar",
      unit: "Birim",
      unitPrice: "Birim fiyat (KDV hari\xE7)",
      vat: "KDV",
      net: "Tutar",
      subtotal: "Ara toplam",
      vatLine: "KDV %{{rate}}",
      total: "Genel toplam",
      dueAt: "Son \xF6deme tarihi",
      notes: "Notlar",
      saveDraft: "Tasla\u011F\u0131 kaydet",
      issue: "Faturay\u0131 kes",
      issueConfirm: "Fatura numaras\u0131 verilecek ve belge kilitlenecek.",
      issued: "Fatura kesildi: {{number}}",
      delete: "Tasla\u011F\u0131 sil",
      deleted: "Taslak silindi.",
      pdf: "PDF",
      send: "E-postayla g\xF6nder",
      sendTo: "Al\u0131c\u0131 e-posta",
      sent: "Fatura g\xF6nderildi.",
      credit: "\u0130ade faturas\u0131",
      creditTitle: "\u0130ade faturas\u0131 olu\u015Ftur",
      creditAmount: "\u0130ade tutar\u0131 (KDV dahil)",
      creditHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa kalan tutar\u0131n tamam\u0131 ({{amount}}).",
      credited: "\u0130ade faturas\u0131 kesildi: {{number}}",
      cancel: "Faturay\u0131 iptal et",
      cancelHint: "\u0130ptal edilen fatura ge\xE7ersiz say\u0131l\u0131r; e-Ar\u015Fiv entegrasyonu a\xE7\u0131ksa iptal bildirilir.",
      cancelled: "Fatura iptal edildi.",
      eInvoice: "e-Ar\u015Fiv: {{status}}",
      creditNotes: "\u0130ade faturalar\u0131",
      credits: "\u0130lgili fatura: {{number}}",
      locked: "Kesilmi\u015F fatura d\xFCzenlenemez; iptal edin veya iade faturas\u0131 olu\u015Fturun.",
      back: "Faturalara d\xF6n",
      booking: "Rezervasyon",
      tripPlan: "Seyahat plan\u0131",
      deleteConfirm: "Taslak kal\u0131c\u0131 olarak silinecek; numara verilmedi\u011Fi i\xE7in s\u0131ra etkilenmez."
    },
    reports: {
      cashFlow: "Nakit ak\u0131\u015F\u0131",
      profitability: "K\xE2rl\u0131l\u0131k",
      groupBy: "Gruplama",
      allAccounts: "T\xFCm hesaplar (virmanlar hari\xE7)",
      allCategories: "T\xFCm kategoriler",
      inflow: "Giri\u015F",
      outflow: "\xC7\u0131k\u0131\u015F",
      net: "Net",
      accountRows: "Hesap baz\u0131nda",
      opening: "A\xE7\u0131l\u0131\u015F",
      closing: "Kapan\u0131\u015F",
      byType: "Hareket t\xFCr\xFCne g\xF6re",
      revenue: "Gelir",
      refunds: "\u0130ade",
      expenses: "Gider",
      margin: "Marj",
      bookings: "Rezervasyon",
      overheads: "\u0130lana ba\u011Fl\u0131 olmayan genel giderler: {{amount}}",
      note: "Tutarlar her hareketin kendi tarihindeki kurla TRY kar\u015F\u0131l\u0131\u011F\u0131d\u0131r; k\xE2rl\u0131l\u0131k nakit esasl\u0131 ve KDV dahildir.",
      run: "G\xF6ster"
    },
    rates: {
      subtitle: "1 birim d\xF6vizin TRY kar\u015F\u0131l\u0131\u011F\u0131; raporlar her hareketin kendi tarihindeki kuru kullan\u0131r.",
      latest: "G\xFCncel kurlar",
      manual: "Elle kur gir",
      base: "D\xF6viz",
      rate: "Kur (TRY)",
      effectiveDate: "Ge\xE7erlilik tarihi",
      saved: "Kur kaydedildi.",
      refresh: "TCMB\u2019den g\xFCncelle",
      refreshed: "{{date}} tarihli {{count}} kur al\u0131nd\u0131.",
      autoOn: "Otomatik g\xFCncelleme a\xE7\u0131k (hafta i\xE7i 16:00, TCMB d\xF6viz al\u0131\u015F).",
      autoOff: "Otomatik g\xFCncelleme kapal\u0131 (FX_AUTO_UPDATE).",
      history: "Ge\xE7mi\u015F",
      source: "Kaynak"
    }
  },
  services: {
    title: "Hizmet talepleri",
    subtitle: "Sahip hizmetleri talepleri, teklifler, i\u015F emirleri ve periyodik planlar.",
    tabs: {
      board: "Pano",
      list: "Liste",
      quotes: "Teklifler",
      plans: "Periyodik planlar"
    },
    new: "Yeni talep",
    search: "Kod, m\xFC\u015Fteri veya varl\u0131k ara\u2026",
    empty: "Bu kriterlere uygun talep yok.",
    boardHint: "Kartlar\u0131 s\xFCr\xFCkleyerek durumu de\u011Fi\u015Ftirin. Teklif, m\xFC\u015Fteri karar\u0131, planlama ve fatura ad\u0131mlar\u0131 ilgili belgeden ilerler.",
    moved: 'Talep "{{status}}" durumuna ta\u015F\u0131nd\u0131.',
    dragCard: "{{code}} talebini ta\u015F\u0131",
    more: "+{{count}} talep daha",
    columns: {
      code: "Kod",
      customer: "M\xFC\u015Fteri",
      service: "Hizmet",
      preferred: "Tercih edilen tarih",
      quote: "Teklif",
      status: "Durum"
    },
    actions: {
      SEND_QUOTE: "Bu ad\u0131m i\xE7in teklif g\xF6nderin.",
      QUOTE_DECISION: "Bu ad\u0131m m\xFC\u015Fterinin teklif karar\u0131yla ilerler.",
      SCHEDULE_WORK_ORDER: "Bu ad\u0131m i\xE7in i\u015F emrinin tarihini girin.",
      ISSUE_INVOICE: "Bu ad\u0131m i\xE7in i\u015F emrinden fatura kesin."
    },
    detail: {
      back: "Hizmet taleplerine d\xF6n",
      request: "Talep",
      items: "\u0130stenen hizmetler",
      asset: "Varl\u0131k",
      make: "Marka / model",
      registration: "Tescil / plaka",
      length: "Boy",
      location: "Konum",
      preferred: "Tercih edilen tarih",
      notes: "M\xFC\u015Fteri notu",
      photos: "Foto\u011Fraflar",
      customer: "M\xFC\u015Fteri",
      handling: "Takip",
      assignee: "Sorumlu",
      unassigned: "Atanmam\u0131\u015F",
      internalNotes: "\u0130\xE7 notlar",
      save: "Kaydet",
      saved: "Kaydedildi",
      timeline: "Durum ge\xE7mi\u015Fi",
      move: "Durumu de\u011Fi\u015Ftir",
      moveTo: '"{{status}}" durumuna ta\u015F\u0131',
      reason: "Gerek\xE7e (iste\u011Fe ba\u011Fl\u0131)",
      quotes: "Teklifler",
      newQuote: "Teklif haz\u0131rla",
      openDraft: "Tasla\u011F\u0131 a\xE7",
      noQuotes: "Hen\xFCz teklif yok.",
      workOrders: "\u0130\u015F emirleri",
      noWorkOrders: "Teklif onaylan\u0131nca i\u015F emri olu\u015Fur.",
      money: "\xD6demeler",
      paid: "Tahsil edilen",
      collect: "Tahsilat kaydet",
      collected: "Tahsilat kaydedildi",
      refund: "\u0130ade",
      refunded: "\u0130ade i\u015Flendi",
      noPayments: "Hen\xFCz \xF6deme yok.",
      refundHint: "\u0130ade edilebilir tutar {{amount}}. \u0130ade \xF6nce en yeni tahsilattan yap\u0131l\u0131r.",
      kind: "T\xFCr",
      method: "Y\xF6ntem",
      amount: "Tutar",
      account: "Hesap",
      refundAccount: "\xD6deme hesab\u0131 (havale/nakit iadesi)",
      reference: "Dekont / referans no"
    },
    create: {
      title: "Telefonla gelen talep",
      hint: "Telefon, WhatsApp veya e-postayla gelen talebi kay\u0131tl\u0131 bir m\xFC\u015Fteri ad\u0131na olu\u015Fturun.",
      customer: "M\xFC\u015Fteri",
      customerSearch: "Ad, e-posta veya telefon\u2026",
      noCustomers: "M\xFC\u015Fteri bulunamad\u0131.",
      service: "Hizmet",
      source: "Kaynak",
      items: "Hizmetler",
      asset: "Varl\u0131k",
      newAsset: "Yeni varl\u0131k",
      assetName: "Varl\u0131k ad\u0131",
      registration: "Tescil / plaka",
      make: "Marka",
      model: "Model",
      from: "Ba\u015Flang\u0131\xE7",
      to: "Biti\u015F",
      notes: "M\xFC\u015Fteri notu",
      internalNotes: "\u0130\xE7 not",
      created: "{{code}} talebi olu\u015Fturuldu"
    },
    quotesList: {
      code: "Teklif",
      validUntil: "Ge\xE7erlilik",
      total: "Toplam",
      empty: "Teklif yok."
    },
    plans: {
      new: "Yeni plan",
      empty: "Hen\xFCz periyodik plan yok.",
      saved: "Plan kaydedildi",
      active: "Aktif",
      inactive: "Pasif",
      noStaff: "Personel atanmad\u0131",
      run: "S\u0131radaki i\u015F emrini \u015Fimdi olu\u015Ftur",
      ran: "\u0130\u015F emri olu\u015Fturuldu",
      delete: "Plan\u0131 sil",
      deleteConfirm: "Plan silinsin mi? \u0130\u015F emri olu\u015Fmu\u015F planlar pasife al\u0131n\u0131r.",
      workOrders: "{{count}} i\u015F emri",
      columns: {
        name: "Plan",
        rule: "Tekrar",
        next: "S\u0131radaki",
        price: "Fiyat",
        status: "Durum"
      },
      fields: {
        customer: "M\xFC\u015Fteri",
        name: "Plan ad\u0131",
        service: "Hizmet",
        asset: "Varl\u0131k",
        frequency: "S\u0131kl\u0131k",
        interval: "Aral\u0131k",
        weekdays: "G\xFCnler",
        monthDay: "Ay\u0131n g\xFCn\xFC",
        month: "Ay",
        startsOn: "Ba\u015Flang\u0131\xE7",
        endsOn: "Biti\u015F",
        startTime: "Ba\u015Flang\u0131\xE7 saati",
        durationHours: "S\xFCre (saat)",
        leadDays: "Ka\xE7 g\xFCn \xF6nce olu\u015Fturulsun",
        staff: "Personel",
        price: "Fiyat (KDV hari\xE7)",
        vat: "KDV",
        notes: "Notlar",
        active: "Plan aktif"
      },
      frequencies: {
        DAILY: "G\xFCnl\xFCk",
        WEEKLY: "Haftal\u0131k",
        MONTHLY: "Ayl\u0131k",
        YEARLY: "Y\u0131ll\u0131k"
      },
      every: {
        DAILY: "{{count}} g\xFCnde bir",
        WEEKLY: "{{count}} haftada bir",
        MONTHLY: "{{count}} ayda bir",
        YEARLY: "{{count}} y\u0131lda bir"
      },
      weekdays: {
        MO: "Pzt",
        TU: "Sal",
        WE: "\xC7ar",
        TH: "Per",
        FR: "Cum",
        SA: "Cmt",
        SU: "Paz"
      }
    }
  },
  quotes: {
    title: "Teklif",
    back: "Tekliflere d\xF6n",
    version: "Revizyon {{version}}",
    versions: "Revizyonlar",
    lines: "Kalemler",
    addLine: "Kalem ekle",
    type: "T\xFCr",
    description: "A\xE7\u0131klama",
    quantity: "Miktar",
    unit: "Birim",
    unitPrice: "Birim fiyat",
    discount: "\u0130ndirim %",
    vat: "KDV",
    net: "Tutar",
    totals: {
      subtotal: "Ara toplam",
      discount: "\u0130ndirim",
      vat: "KDV %{{rate}}",
      total: "Genel toplam",
      deposit: "\xD6n \xF6deme"
    },
    settings: "Ko\u015Fullar",
    validUntil: "Ge\xE7erlilik",
    deposit: "\xD6n \xF6deme %",
    depositHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa m\xFC\u015Fteri tamam\u0131n\u0131 \xF6der.",
    notes: "M\xFC\u015Fteriye not",
    terms: "Ko\u015Fullar",
    internalNotes: "\u0130\xE7 not",
    save: "Tasla\u011F\u0131 kaydet",
    saved: "Taslak kaydedildi",
    send: "G\xF6nder",
    resend: "Yeniden g\xF6nder",
    sendHint: "Teklif PDF olarak ve online onay ba\u011Flant\u0131s\u0131yla e-postayla g\xF6nderilir.",
    sendTo: "Al\u0131c\u0131",
    sendToHint: "Bo\u015Fsa m\xFC\u015Fterinin e-postas\u0131",
    message: "Mesaj (iste\u011Fe ba\u011Fl\u0131)",
    sent: "Teklif g\xF6nderildi",
    delete: "Tasla\u011F\u0131 sil",
    deleteConfirm: "Taslak kal\u0131c\u0131 olarak silinsin mi?",
    deleted: "Taslak silindi",
    pdf: "PDF",
    revise: "Revize et",
    revised: "Yeni revizyon olu\u015Fturuldu",
    cancel: "Geri \xE7ek",
    cancelled: "Teklif geri \xE7ekildi",
    accept: "M\xFC\u015Fteri ad\u0131na onayla",
    accepted: "Teklif onayland\u0131, i\u015F emri olu\u015Fturuldu",
    reject: "M\xFC\u015Fteri ad\u0131na reddet",
    rejected: "Teklif reddedildi",
    reason: "Not / gerek\xE7e",
    copyLink: "Onay ba\u011Flant\u0131s\u0131n\u0131 kopyala",
    linkCopied: "Ba\u011Flant\u0131 kopyaland\u0131",
    locked: "G\xF6nderilmi\u015F teklif de\u011Fi\u015Ftirilemez; de\u011Fi\u015Fiklik i\xE7in revize edin.",
    customer: "M\xFC\u015Fteri",
    sentAt: "G\xF6nderilme",
    viewedAt: "G\xF6r\xFCnt\xFClenme",
    paid: "\xD6denen",
    balance: "Kalan",
    createdBy: "Haz\u0131rlayan",
    workOrder: "\u0130\u015F emri"
  },
  tripPlans: {
    title: "Seyahat planlar\u0131",
    subtitle: "Sitede planlanan seyahatler: kapora, b\xF6l\xFCm b\xF6l\xFCm teyit, kesin fiyat ve bakiye.",
    search: "Kod, misafir veya e-posta ara",
    allStatuses: "T\xFCm durumlar",
    empty: "Hen\xFCz seyahat plan\u0131 yok.",
    columns: {
      code: "Kod",
      customer: "Misafir",
      destination: "Destinasyon",
      dates: "Tarihler",
      estimate: "Tahmin",
      paid: "\xD6denen",
      status: "Durum"
    },
    guests: "{{count}} ki\u015Fi",
    nights: "{{count}} gece",
    party: "{{adults}} yeti\u015Fkin, {{children}} \xE7ocuk",
    expires: "Kapora son tarihi: {{date}}",
    actions: {
      REVIEW: "\u0130ncelemeye al",
      CONFIRM: "Onayla",
      COMPLETE: "Tamamland\u0131 say",
      CANCEL: "\u0130ptal et"
    },
    actionDone: "Plan g\xFCncellendi.",
    confirm: {
      title: "Seyahati onayla",
      total: "Kesin toplam ({{currency}})",
      message: "Misafire mesaj",
      hint: "Misafire kesin fiyat ve kalan bakiyeyle onay e-postas\u0131 gider."
    },
    cancel: {
      title: "Plan iptal edilsin mi?",
      message: "\u0130ptal nedeni (misafire gider)",
      hint: "Takvim bloklar\u0131 kald\u0131r\u0131l\u0131r. \xD6demeleri iade etmek i\xE7in \u0130ade d\xFC\u011Fmesini kullan\u0131n."
    },
    items: {
      title: "B\xF6l\xFCmler",
      day: "{{day}}. g\xFCn",
      days: "{{from}}\u2013{{to}}. g\xFCn",
      team: "Ekibimiz ayarlayacak",
      onRequest: "Ekip fiyatland\u0131racak",
      roundTrip: "gidi\u015F-d\xF6n\xFC\u015F",
      daysCount: "{{count}} g\xFCn",
      withDriver: "\u015Fof\xF6rl\xFC",
      selfDrive: "\u015Fof\xF6rs\xFCz",
      blocked: "Takvimde bloklu",
      exclusive: "Ayr\u0131ld\u0131\u011F\u0131nda takvimde bloklan\u0131r",
      pooled: "Otel teyidiyle ayr\u0131l\u0131r",
      reference: "Referans no",
      note: "Not",
      saved: "B\xF6l\xFCm g\xFCncellendi."
    },
    totals: {
      title: "Tutarlar",
      estimate: "Tahmini toplam",
      deposit: "Kapora",
      confirmed: "Onaylanan toplam",
      paid: "\xD6denen",
      balance: "Kalan bakiye",
      onRequest: "Fiyat\u0131 ekip\xE7e belirlenecek b\xF6l\xFCm: {{count}}"
    },
    payments: "\xD6demeler",
    invoices: {
      title: "Faturalar",
      empty: "Hen\xFCz fatura yok.",
      afterConfirm: "Fatura, plan onayland\u0131ktan sonra kesilir.",
      create: "Fatura tasla\u011F\u0131 olu\u015Ftur",
      created: "Fatura tasla\u011F\u0131 olu\u015Fturuldu."
    },
    history: "Ge\xE7mi\u015F",
    contact: "\u0130leti\u015Fim",
    customerCard: "M\xFC\u015Fteri kart\u0131",
    marketing: "Kampanya izni var",
    brief: {
      title: "Planlama tercihleri",
      occasion: "Vesile",
      transport: "Ula\u015F\u0131m",
      departure: "Kalk\u0131\u015F",
      stay: "Konaklama",
      yachtDays: "Yat g\xFCn\xFC",
      car: "Ara\xE7",
      interests: "\u0130lgi alanlar\u0131",
      notes: "Misafir notu"
    },
    occasions: {
      LEISURE: "Tatil",
      HONEYMOON: "Balay\u0131",
      ANNIVERSARY: "Y\u0131l d\xF6n\xFCm\xFC",
      FAMILY: "Aile",
      FRIENDS: "Arkada\u015Flar",
      BUSINESS: "\u0130\u015F",
      CELEBRATION: "Kutlama"
    },
    transports: {
      PRIVATE_JET: "\xD6zel jet",
      VIP_ARRIVAL: "Tarifeli u\xE7u\u015F + VIP kar\u015F\u0131lama",
      OWN_YACHT: "Kendi yat\u0131",
      IN_TURKEY: "Zaten T\xFCrkiye\u2019de"
    },
    stays: {
      PALACE: "Saray oteli & resort",
      BOUTIQUE: "Butik otel",
      VILLA: "\xD6zel villa",
      NONE: "Konaklama yok"
    },
    cars: {
      NONE: "Ara\xE7 yok",
      SELF_DRIVE: "Kendisi kullanacak",
      CHAUFFEUR: "Tam g\xFCn \u015Fof\xF6rl\xFC",
      TRANSFERS: "Yaln\u0131zca transfer"
    },
    interests: {
      GASTRONOMY: "Gastronomi",
      CULTURE: "K\xFClt\xFCr & tarih",
      WELLNESS: "Wellness",
      ADVENTURE: "G\xF6ky\xFCz\xFC & macera",
      SEA: "Deniz",
      NIGHTLIFE: "Gece hayat\u0131"
    }
  },
  serviceCatalog: {
    title: "Hizmet katalo\u011Fu",
    subtitle: "Sitede sunulan sahip hizmetleri: kapsam, paketler, s\xFCre\xE7, referanslar ve taahh\xFCtler.",
    new: "Yeni hizmet",
    empty: "Hen\xFCz hizmet yok.",
    saved: "Hizmet kaydedildi",
    active: "Yay\u0131nda",
    inactive: "Pasif",
    packages: "Paket: {{count}}",
    requests: "Talep: {{count}}",
    viewOnSite: "Sitede g\xF6r\xFCnt\xFCle",
    guarantee: "Taahh\xFCt",
    fields: {
      name: "Hizmet ad\u0131",
      summary: "K\u0131sa a\xE7\u0131klama",
      intro: "Giri\u015F metni",
      key: "Anahtar",
      keyHint: "Olu\u015Fturulduktan sonra de\u011Fi\u015Ftirilemez (\xF6r. yacht-maintenance).",
      slug: "Adres (slug)",
      assetType: "Varl\u0131k t\xFCr\xFC",
      anyAsset: "T\xFCm varl\u0131k t\xFCrleri",
      icon: "\u0130kon",
      sortOrder: "S\u0131ra",
      active: "Sitede yay\u0131nda"
    },
    sections: {
      scope: "Kapsam kalemleri",
      stats: "\u0130statistikler",
      process: "S\xFCre\xE7 ad\u0131mlar\u0131",
      tiers: "Paketler",
      references: "Referans vakalar",
      guarantees: "Taahh\xFCtler"
    },
    items: {
      key: "Anahtar",
      name: "Kalem ad\u0131",
      description: "A\xE7\u0131klama",
      active: "Kalem aktif",
      hint: "Talep formunda se\xE7ilebilen kalemler. Listeden \xE7\u0131kar\u0131lan kalemler ge\xE7mi\u015F talepler i\xE7in pasif olarak saklan\u0131r."
    },
    stats: {
      value: "De\u011Fer",
      label: "Etiket"
    },
    process: {
      title: "Ad\u0131m ba\u015Fl\u0131\u011F\u0131",
      body: "A\xE7\u0131klama"
    },
    tiers: {
      key: "Anahtar",
      name: "Paket ad\u0131",
      tagline: "Alt ba\u015Fl\u0131k",
      price: "Ba\u015Flang\u0131\xE7 fiyat\u0131",
      priceHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa \u201Cfiyat talep \xFCzerine\u201D g\xF6sterilir.",
      currency: "Para birimi",
      period: "D\xF6nem",
      periods: {
        MONTH: "Ayl\u0131k",
        YEAR: "Y\u0131ll\u0131k",
        JOB: "\u0130\u015F ba\u015F\u0131na"
      },
      response: "Yan\u0131t s\xFCresi",
      features: "\xD6zellik",
      featured: "\xD6ne \xE7\u0131kan paket"
    },
    references: {
      title: "Ba\u015Fl\u0131k",
      detail: "Detay",
      metric: "Sonu\xE7 (\xF6r. %18 tasarruf)"
    }
  },
  workOrders: {
    title: "\u0130\u015F emirleri",
    subtitle: "Onaylanan tekliflerden ve periyodik planlardan olu\u015Fan i\u015Fler: planlama, personel, g\xF6revler ve foto\u011Fraflar.",
    search: "\u0130\u015F emri, talep veya m\xFC\u015Fteri ara\u2026",
    empty: "Bu kriterlere uygun i\u015F emri yok.",
    unscheduled: "Yaln\u0131zca planlanmam\u0131\u015Flar",
    columns: {
      code: "\u0130\u015F emri",
      customer: "M\xFC\u015Fteri",
      schedule: "Planlanan zaman",
      staff: "Personel",
      tasks: "G\xF6revler",
      status: "Durum"
    },
    detail: {
      back: "\u0130\u015F emirlerine d\xF6n",
      schedule: "Planlama",
      start: "Ba\u015Flang\u0131\xE7",
      end: "Biti\u015F",
      location: "Konum",
      notes: "Notlar",
      save: "Kaydet",
      saved: "\u0130\u015F emri kaydedildi",
      scheduleHint: "Tarih girildi\u011Finde i\u015F emri planlan\u0131r ve m\xFC\u015Fteriye bildirilir.",
      moved: '\u0130\u015F emri "{{status}}" durumuna ge\xE7ti',
      moves: {
        PLANNED: "Planlamaya al",
        SCHEDULED: "Planland\u0131",
        IN_PROGRESS: "\u0130\u015Fe ba\u015Fla",
        ON_HOLD: "Beklet",
        COMPLETED: "Tamamla",
        CANCELLED: "\u0130ptal et"
      },
      tasks: "G\xF6revler",
      progress: "{{done}}/{{total}} tamamland\u0131",
      noTasks: "Hen\xFCz g\xF6rev yok.",
      taskTitle: "Yeni g\xF6rev",
      addTask: "Ekle",
      assignee: "Sorumlu",
      staff: "Personel",
      noStaff: "Hen\xFCz personel atanmad\u0131.",
      person: "Personel",
      role: "G\xF6rev",
      assign: "Personel ata",
      assigned: "Personel atand\u0131",
      assignedWithConflicts: "Personel atand\u0131; \xE7ak\u0131\u015Fma uyar\u0131s\u0131n\u0131 kontrol edin",
      conflictAssignment: "{{label}} ile \xE7ak\u0131\u015F\u0131yor",
      conflictUnavailable: "{{label}} kayd\u0131yla \xE7ak\u0131\u015F\u0131yor",
      photos: "Foto\u011Fraflar",
      noPhotos: "Hen\xFCz foto\u011Fraf yok.",
      phase: "A\u015Fama",
      caption: "A\xE7\u0131klama",
      upload: "Foto\u011Fraf y\xFCkle",
      request: "Talep",
      quote: "Teklif",
      startedAt: "Ba\u015Flang\u0131\xE7",
      completedAt: "Tamamlanma",
      invoices: "Faturalar",
      noInvoices: "Hen\xFCz fatura yok.",
      invoice: "Fatura tasla\u011F\u0131 olu\u015Ftur",
      invoiced: "Fatura tasla\u011F\u0131 olu\u015Fturuldu",
      expenses: "Giderler",
      noExpenses: "Bu i\u015Fe ba\u011Fl\u0131 gider yok."
    }
  },
  staff: {
    title: "Personel",
    subtitle: "Kaptan, m\xFCrettebat, \u015Fof\xF6r ve teknisyenler; belgeler, izinler, g\xF6revler ve hakedi\u015Fler.",
    tabs: {
      list: "Liste",
      calendar: "Takvim",
      documents: "Belge uyar\u0131lar\u0131"
    },
    new: "Yeni personel",
    search: "Ad, kod, telefon veya e-posta\u2026",
    empty: "Personel bulunamad\u0131.",
    documentsFilter: "Belge uyar\u0131s\u0131 olanlar",
    statuses: {
      active: "Aktif",
      inactive: "Pasif",
      all: "T\xFCm\xFC"
    },
    columns: {
      name: "Ad soyad",
      role: "Rol",
      contact: "\u0130leti\u015Fim",
      documents: "Belgeler",
      next: "S\u0131radaki g\xF6rev",
      status: "Durum"
    },
    expired: "{{count}} s\xFCresi dolmu\u015F",
    expiring: "{{count}} yakla\u015Fan",
    expiringList: {
      empty: "S\xFCresi dolmu\u015F veya 30 g\xFCn i\xE7inde dolacak belge yok.",
      document: "Belge",
      expiresAt: "Ge\xE7erlilik",
      expired: "S\xFCresi doldu",
      daysLeft: "{{days}} g\xFCn kald\u0131"
    },
    form: {
      firstName: "Ad",
      lastName: "Soyad",
      role: "Rol",
      employment: "\xC7al\u0131\u015Fma \u015Fekli",
      email: "E-posta",
      phone: "Telefon",
      nationalId: "T.C. kimlik no",
      nationalIdHint: "\u015Eifreli saklan\u0131r; bo\u015F b\u0131rak\u0131l\u0131rsa kay\u0131tl\u0131 de\u011Fer korunur.",
      hiredAt: "\u0130\u015Fe ba\u015Flama",
      salary: "Ayl\u0131k maa\u015F",
      dailyRate: "G\xFCnl\xFCk \xFCcret",
      skills: "Yetkinlikler (virg\xFClle)",
      languages: "Diller (\xF6rn. tr, en)",
      notes: "Notlar",
      active: "Aktif",
      saved: "Personel kaydedildi"
    },
    calendar: {
      previous: "\xD6nceki hafta",
      next: "Sonraki hafta",
      today: "Bu hafta",
      empty: "G\xF6sterilecek personel yok.",
      legendWork: "G\xF6rev",
      legendLeave: "\u0130zin / m\xFCsait de\u011Fil",
      legendConflict: "\xC7ak\u0131\u015Fma"
    },
    detail: {
      back: "Personel listesine d\xF6n",
      profile: "Profil",
      archive: "Ar\u015Fivle",
      archiveConfirm: "Personel ar\u015Fivlensin mi? Yakla\u015Fan g\xF6revi olan personel ar\u015Fivlenemez.",
      archived: "Personel ar\u015Fivlendi",
      stats: {
        assignments: "Son 90 g\xFCn g\xF6rev",
        hours: "Son 90 g\xFCn saat",
        paid: "Son 90 g\xFCn \xF6deme"
      },
      documents: "Belgeler",
      addDocument: "Belge ekle",
      noDocuments: "Kay\u0131tl\u0131 belge yok.",
      documentType: "Belge t\xFCr\xFC",
      number: "Belge no",
      issuedAt: "Verili\u015F",
      expiresAt: "Ge\xE7erlilik",
      uploadFile: "Dosya y\xFCkle",
      viewFile: "Dosyay\u0131 a\xE7",
      availability: "\u0130zin & m\xFCsaitlik",
      addAvailability: "Kay\u0131t ekle",
      noAvailability: "Kay\u0131t yok.",
      availabilityType: "T\xFCr",
      from: "Ba\u015Flang\u0131\xE7",
      to: "Biti\u015F",
      note: "Not",
      assignments: "G\xF6revler",
      noAssignments: "G\xF6rev yok.",
      conflicts: "{{count}} \xE7ak\u0131\u015Fma",
      payouts: "Hakedi\u015F & maa\u015F",
      addPayout: "\xD6deme kaydet",
      noPayouts: "\xD6deme kayd\u0131 yok.",
      description: "A\xE7\u0131klama",
      amount: "Tutar",
      account: "\xD6deme hesab\u0131",
      paid: "\xD6deme kaydedildi"
    },
    booking: {
      title: "Personel",
      empty: "Bu rezervasyona personel atanmad\u0131."
    }
  },
  serviceEnums: {
    staffRole: {
      CAPTAIN: "Kaptan",
      CREW: "M\xFCrettebat",
      CHEF: "\u015Eef",
      HOSTESS: "Hostes",
      CHAUFFEUR: "\u015Eof\xF6r",
      TECHNICIAN: "Teknisyen",
      OPERATIONS: "Operasyon",
      PILOT: "Pilot",
      FLIGHT_ATTENDANT: "Kabin g\xF6revlisi"
    },
    employmentType: {
      FULL_TIME: "Tam zamanl\u0131",
      PART_TIME: "Yar\u0131 zamanl\u0131",
      SEASONAL: "Sezonluk",
      CONTRACTOR: "Serbest / s\xF6zle\u015Fmeli"
    },
    assignmentStatus: {
      ASSIGNED: "Atand\u0131",
      CONFIRMED: "Onayland\u0131",
      CHECKED_IN: "G\xF6revde",
      COMPLETED: "Tamamland\u0131",
      CANCELLED: "\u0130ptal"
    },
    availabilityType: {
      AVAILABLE: "M\xFCsait",
      UNAVAILABLE: "M\xFCsait de\u011Fil",
      LEAVE: "\u0130zin",
      SICK: "Raporlu",
      SHIFT: "Vardiya"
    },
    documentType: {
      DRIVER_LICENSE: "S\xFCr\xFCc\xFC belgesi",
      CAPTAIN_LICENSE: "Kaptan yeterlilik belgesi",
      SRC_CERTIFICATE: "SRC belgesi",
      HEALTH_REPORT: "Sa\u011Fl\u0131k raporu",
      PASSPORT: "Pasaport",
      PILOT_LICENSE: "Pilot lisans\u0131",
      MEDICAL_CERTIFICATE: "Sa\u011Fl\u0131k sertifikas\u0131",
      CRIMINAL_RECORD: "Adli sicil kayd\u0131",
      OTHER: "Di\u011Fer"
    },
    documentState: {
      EXPIRED: "S\xFCresi doldu",
      EXPIRING: "Yakla\u015F\u0131yor",
      VALID: "Ge\xE7erli",
      NO_EXPIRY: "S\xFCresiz"
    },
    mediaPhase: {
      BEFORE: "\xD6ncesi",
      DURING: "\u0130\u015F s\u0131ras\u0131nda",
      AFTER: "Sonras\u0131",
      SIGNATURE: "\u0130mza"
    }
  },
  reports: {
    title: "Raporlar",
    subtitle: "Sat\u0131\u015F, doluluk, kategori, m\xFC\u015Fteri kazan\u0131m\u0131, iptal, personel ve hizmet d\xF6n\xFC\u015F\xFCm\xFC \u2014 d\xF6nem kar\u015F\u0131la\u015Ft\u0131rma ve d\u0131\u015Fa aktar\u0131mla.",
    titles: {
      sales: "Sat\u0131\u015F",
      occupancy: "Doluluk",
      categories: "Kategori performans\u0131",
      acquisition: "M\xFC\u015Fteri kazan\u0131m\u0131",
      cancellations: "\u0130ptal analizi",
      staff: "Personel verimlili\u011Fi",
      serviceConversion: "Hizmet talebi d\xF6n\xFC\u015F\xFCm\xFC"
    },
    descriptions: {
      sales: "D\xF6nemde olu\u015Fturulan rezervasyonlar, de\u011Ferleri ve net tahsilat.",
      occupancy: "Yay\u0131ndaki ilanlar\u0131n dolu saatleri ile m\xFCsait saatlerin oran\u0131.",
      categories: "Kategori bazl\u0131 tahsilat, gider ve net sonu\xE7 (nakit esasl\u0131).",
      acquisition: "Yeni m\xFC\u015Fteriler, ilk kez ve tekrar rezervasyon yapanlar, talepler ve kanallar.",
      cancellations: "D\xF6nemin iptal edilen rezervasyonlar\u0131, iadeler ve kaybedilen de\u011Fer.",
      staff: "Ki\u015Fi bazl\u0131 g\xF6revler, saatler, tamamlanan i\u015F emirleri ve \xF6demeler.",
      serviceConversion: "Sahip hizmeti talebinden teklife, onaya ve tamamlanmaya."
    },
    metrics: {
      bookings: "Rezervasyon",
      bookedValue: "Sat\u0131\u015F de\u011Feri",
      netCollected: "Net tahsilat",
      averageBasket: "Ortalama sepet",
      occupancy: "Doluluk",
      bookedHours: "Dolu saat",
      capacityHours: "M\xFCsait saat",
      expenses: "Gider",
      net: "Net sonu\xE7",
      cancelled: "\u0130ptal",
      newCustomers: "Yeni m\xFC\u015Fteri",
      firstTimeBookers: "\u0130lk kez rezervasyon",
      returningBookers: "Tekrar gelen",
      leads: "Talep",
      leadConversion: "Talep d\xF6n\xFC\u015F\xFCm\xFC",
      cancellationRate: "\u0130ptal oran\u0131",
      refunded: "\u0130ade",
      lostValue: "Kaybedilen de\u011Fer",
      activeStaff: "Aktif personel",
      assignments: "G\xF6rev",
      assignedHours: "G\xF6rev saati",
      payouts: "Hakedi\u015F",
      completedWorkOrders: "Tamamlanan i\u015F emri",
      requests: "Talep",
      quoted: "Teklif verilen",
      accepted: "Onaylanan",
      completed: "Tamamlanan",
      conversion: "D\xF6n\xFC\u015F\xFCm",
      averageQuote: "Ortalama teklif"
    },
    rows: {
      services: "Sahip hizmetleri",
      general: "Genel (atanmam\u0131\u015F)"
    },
    columns: {
      group: "Grup"
    },
    period: "D\xF6nem: {{from}} \u2013 {{to}}",
    periodLabel: "D\xF6nem",
    filters: {
      from: "Ba\u015Flang\u0131\xE7",
      to: "Biti\u015F",
      compare: "Kar\u015F\u0131la\u015Ft\u0131r",
      groupBy: "Gruplama",
      category: "Kategori",
      allCategories: "T\xFCm kategoriler"
    },
    compare: {
      none: "Kar\u015F\u0131la\u015Ft\u0131rma yok",
      previous: "\xD6nceki d\xF6nem",
      lastYear: "Ge\xE7en y\u0131l ayn\u0131 d\xF6nem"
    },
    grouping: {
      DAY: "G\xFCn",
      WEEK: "Hafta",
      MONTH: "Ay"
    },
    vsPrevious: "\xF6nceki: {{value}}",
    noBase: "kar\u015F\u0131la\u015Ft\u0131rma yok",
    previousSeries: "Kar\u015F\u0131la\u015Ft\u0131rma",
    currentSeries: "Bu d\xF6nem",
    empty: "Bu d\xF6nem i\xE7in veri yok.",
    export: "D\u0131\u015Fa aktar",
    schedule: {
      title: "Zamanlanm\u0131\u015F e-posta",
      off: "Zamanlanm\u0131\u015F rapor e-postas\u0131 kapal\u0131.",
      on: "{{frequency}} rapor, {{count}} al\u0131c\u0131ya.",
      WEEKLY: "Haftal\u0131k",
      MONTHLY: "Ayl\u0131k",
      sendNow: "\u015Eimdi g\xF6nder",
      sent: "Rapor {{count}} al\u0131c\u0131ya g\xF6nderildi.",
      none: "\xD6nce ayarlardan al\u0131c\u0131 ekleyin.",
      configure: "Ayarlardan d\xFCzenle"
    },
    hours: "{{value}} sa",
    presets: {
      thisMonth: "Bu ay",
      lastMonth: "Ge\xE7en ay",
      last30: "Son 30 g\xFCn",
      thisYear: "Bu y\u0131l"
    }
  },
  dashboardView: {
    subtitle: "Bug\xFCn\xFCn operasyonu, gelir ve tahsilat durumu tek ekranda.",
    degraded: "Baz\u0131 altyap\u0131 servisleri yan\u0131t vermiyor; veriler eksik olabilir.",
    kpis: {
      revenueToday: "Bug\xFCnk\xFC net tahsilat",
      revenueMonth: "Bu ay net tahsilat",
      vsLastMonth: "ge\xE7en ay\u0131n ayn\u0131 g\xFCnlerine g\xF6re",
      collected: "Bu ay tahsil edilen",
      outstanding: "A\xE7\u0131k bakiye: {{amount}}",
      averageBasket: "Ortalama sepet (bu ay)",
      newBookings: "Bug\xFCn yeni rezervasyon",
      thisMonth: "Bu ay: {{count}}",
      occupancy: "Doluluk (bu ay)",
      occupancyHint: "Rezerve saat \xF7 m\xFCsait saat",
      pendingQuotes: "Bekleyen teklif",
      cancellationRate: "\u0130ptal oran\u0131 (90 g\xFCn)",
      cancellationHint: "{{cancelled}} / {{total}} rezervasyon"
    },
    trend: "Son 6 ay gelir (kategori baz\u0131nda)",
    noRevenue: "Son 6 ayda tahsilat kayd\u0131 yok.",
    today: "Bug\xFCn",
    tomorrow: "Yar\u0131n",
    openCalendar: "Takvimi a\xE7",
    noOperations: "Planlanm\u0131\u015F operasyon yok.",
    staff: "Personel: {{names}}",
    noStaff: "Personel atanmad\u0131",
    alerts: "Uyar\u0131lar",
    overdue: "Vadesi ge\xE7mi\u015F \xF6deme: {{count}}",
    documents: "S\xFCresi dolan belge (30 g\xFCn): {{count}}",
    pendingReviews: "Onay bekleyen yorum: {{count}}",
    maintenance: "Yakla\u015Fan bak\u0131m",
    noMaintenance: "\xD6n\xFCm\xFCzdeki 14 g\xFCnde bak\u0131m yok.",
    sources: "Rezervasyon kaynaklar\u0131 (bu ay)",
    noBookings: "Bu ay rezervasyon yok.",
    topAssets: "En \xE7ok kazand\u0131ran ilanlar (90 g\xFCn)",
    updated: "G\xFCncellendi: {{time}}"
  },
  calendar: {
    title: "Operasyon takvimi",
    subtitle: "\u0130lanlar \xD7 g\xFCnler. Bir rezervasyonu s\xFCr\xFCkleyerek yeni saate ta\u015F\u0131y\u0131n; \xE7ak\u0131\u015Fmalar sunucuda kontrol edilir.",
    listing: "\u0130lan",
    previous: "\xD6nceki",
    next: "Sonraki",
    today: "Bug\xFCn",
    from: "Ba\u015Flang\u0131\xE7 tarihi",
    span: "G\xF6r\xFCn\xFCm aral\u0131\u011F\u0131",
    days: "{{count}} g\xFCn",
    category: "Kategori",
    search: "\u0130lan ad\u0131 veya kodu\u2026",
    buffer: "Haz\u0131rl\u0131k tamponu",
    blocked: "Kapal\u0131 d\xF6nem",
    dragHint: "Onayl\u0131 veya bekleyen rezervasyonlar s\xFCr\xFCklenebilir.",
    empty: "Bu filtrelerle ilan bulunamad\u0131.",
    duration: "S\xFCre: {{hours}} saat",
    newStart: "Yeni ba\u015Flang\u0131\xE7 (\u0130stanbul saati)",
    newWindow: "Yeni aral\u0131k: {{from}} \u2192 {{to}}",
    reason: "De\u011Fi\u015Fiklik nedeni",
    reasonHint: "Rezervasyon notlar\u0131na ve denetim kayd\u0131na yaz\u0131l\u0131r.",
    notify: "M\xFC\u015Fteriye e-posta ile bildir",
    locked: "Bu rezervasyon ta\u015F\u0131namaz (ge\xE7mi\u015F, tamamlanm\u0131\u015F ya da yetkiniz yok).",
    openBooking: "Rezervasyonu a\xE7",
    confirmMove: "Ta\u015F\u0131",
    moved: "Rezervasyon yeni saate ta\u015F\u0131nd\u0131."
  },
  customers: {
    title: "M\xFC\u015Fteriler",
    subtitle: "M\xFC\u015Fteri kartlar\u0131, VIP seviyeleri, etiketler, segmentler ve kurumsal hesaplar.",
    tabs: {
      customers: "M\xFC\u015Fteriler",
      corporate: "Kurumsal hesaplar"
    },
    search: "Ad, e-posta veya telefon\u2026",
    segment: "Segment",
    segments: {
      VIP: "VIP (Gold+)",
      HIGH_VALUE: "Y\xFCksek de\u011Fer",
      REPEAT: "Tekrar eden",
      NEW: "Yeni (30 g\xFCn)",
      INACTIVE: "Pasif (12 ay)",
      UPCOMING: "Yakla\u015Fan rezervasyon",
      CORPORATE: "Kurumsal",
      OWNERS: "Ara\xE7/yat sahibi",
      MARKETING: "Pazarlama izni var"
    },
    vipTier: "VIP seviyesi",
    tiers: {
      STANDARD: "Standart",
      SILVER: "Silver",
      GOLD: "Gold",
      PLATINUM: "Platinum",
      BLACK: "Black"
    },
    tag: "Etiket",
    corporate: "Kurumsal hesap",
    sort: "S\u0131ralama",
    sorts: {
      NEWEST: "En yeni",
      NAME: "Ada g\xF6re",
      LTV: "Ya\u015Fam boyu de\u011Fer",
      LAST_ACTIVITY: "Son etkinlik"
    },
    empty: "Bu filtrelerle m\xFC\u015Fteri bulunamad\u0131.",
    count: "Toplam {{count}} m\xFC\u015Fteri",
    columns: {
      customer: "M\xFC\u015Fteri",
      tags: "Etiketler",
      bookings: "Rezervasyon",
      ltv: "Ya\u015Fam boyu de\u011Fer",
      lastActivity: "Son etkinlik",
      users: "Kullan\u0131c\u0131"
    },
    requests: "Hizmet talebi: {{count}}",
    corporateSearch: "Firma ad\u0131, vergi no veya e-posta\u2026",
    corporateStatus: "Durum",
    corporateStatuses: {
      active: "Aktif",
      inactive: "Pasif",
      all: "T\xFCm\xFC"
    },
    corporateEmpty: "Kurumsal hesap yok.",
    corporateForm: {
      new: "Yeni kurumsal hesap",
      name: "Firma ad\u0131",
      legalName: "Ticari unvan",
      taxNumber: "Vergi / TC no",
      taxOffice: "Vergi dairesi",
      email: "E-posta",
      phone: "Telefon",
      currency: "Para birimi",
      creditLimit: "Kredi limiti",
      paymentTerm: "\xD6deme vadesi (g\xFCn)",
      active: "Aktif",
      notes: "Notlar",
      saved: "Kurumsal hesap kaydedildi."
    },
    statuses: {
      ACTIVE: "Aktif",
      SUSPENDED: "Ask\u0131ya al\u0131nd\u0131",
      DELETED: "Silindi"
    },
    channels: {
      IN_APP: "Panel",
      EMAIL: "E-posta",
      SMS: "SMS",
      WHATSAPP: "WhatsApp",
      PUSH: "Bildirim"
    },
    messageStatus: {
      PENDING: "Bekliyor",
      SENT: "G\xF6nderildi",
      FAILED: "Ba\u015Far\u0131s\u0131z",
      READ: "Okundu"
    },
    consentTypes: {
      KVKK_PROCESSING: "KVKK ayd\u0131nlatma",
      TERMS_OF_SERVICE: "Kullan\u0131m ko\u015Fullar\u0131",
      MARKETING_EMAIL: "Pazarlama e-postas\u0131",
      MARKETING_SMS: "Pazarlama SMS",
      MARKETING_WHATSAPP: "Pazarlama WhatsApp",
      COOKIE_FUNCTIONAL: "Zorunlu \xE7erezler",
      COOKIE_ANALYTICS: "Analitik \xE7erezler",
      COOKIE_MARKETING: "Pazarlama \xE7erezleri",
      SENSITIVE_DATA: "\xD6zel nitelikli veri (sa\u011Fl\u0131k/alerji)"
    },
    detail: {
      saved: "M\xFC\u015Fteri kart\u0131 g\xFCncellendi.",
      edit: "Profili d\xFCzenle",
      firstName: "Ad",
      lastName: "Soyad",
      phone: "Telefon",
      tagsHint: "Virg\xFClle ay\u0131r\u0131n, \xF6rn. vip, yat-sahibi",
      dateOfBirth: "Do\u011Fum tarihi",
      nationality: "Uyruk",
      nationalityHint: "ISO kodu, \xF6rn. TR",
      preferredCurrency: "Tercih edilen para birimi",
      acquisitionSource: "Kazan\u0131m kayna\u011F\u0131",
      preferences: "Tercihler",
      preferencesHint: 'Her sat\u0131ra bir tercih: "i\xE7ecek: Maden suyu"',
      sensitiveNotes: "Alerji / sa\u011Fl\u0131k notlar\u0131",
      sensitiveHint: "\u015Eifreli saklan\u0131r; yaln\u0131zca yetkili ekip g\xF6r\xFCr.",
      sensitiveLocked: "M\xFC\u015Fterinin \xF6zel nitelikli veri onay\u0131 yok; bu alan kaydedilemez (KVKK md. 6).",
      internalNotes: "Ekip i\xE7i notlar",
      refunded: "\u0130ade: {{amount}}",
      completedCancelled: "{{completed}} tamamland\u0131 \xB7 {{cancelled}} iptal",
      averageBasket: "Ortalama sepet",
      lastBooking: "Son rezervasyon",
      firstBooking: "\u0130lk rezervasyon: {{date}}",
      tabs: {
        bookings: "Rezervasyonlar",
        services: "Hizmet talepleri",
        payments: "\xD6demeler",
        communications: "\u0130leti\u015Fim ge\xE7mi\u015Fi",
        leads: "Talepler"
      },
      none: "Kay\u0131t yok.",
      code: "Kod",
      date: "Tarih",
      status: "Durum",
      total: "Tutar",
      noMessages: "Hen\xFCz g\xF6nderilmi\u015F mesaj yok.",
      profile: "Profil",
      joined: "Kay\u0131t tarihi",
      emailVerified: "E-posta durumu",
      verified: "Do\u011Fruland\u0131",
      notVerified: "Do\u011Frulanmad\u0131",
      consents: "Onaylar (KVKK)",
      granted: "Verildi",
      withdrawn: "Geri \xE7ekildi",
      ownedAssets: "Kay\u0131tl\u0131 ara\xE7lar\u0131"
    }
  },
  privacy: {
    title: "KVKK talepleri",
    subtitle: "M\xFC\u015Fterilerin veri indirme ve hesap silme talepleri (KVKK md. 11). Silme talepleri en ge\xE7 30 g\xFCn i\xE7inde sonu\xE7land\u0131r\u0131lmal\u0131d\u0131r.",
    search: "M\xFC\u015Fteri ad\u0131 veya e-posta",
    empty: "Talep bulunamad\u0131.",
    types: { EXPORT: "Veri indirme", DELETION: "Hesap silme" },
    statuses: {
      PENDING: "Bekliyor",
      IN_PROGRESS: "\u0130nceleniyor",
      COMPLETED: "Tamamland\u0131",
      REJECTED: "Reddedildi"
    },
    reason: "M\xFC\u015Fterinin notu",
    note: "Karar notu",
    handledBy: "\u0130\u015Fleyen: {{name}}",
    deleted: "Silinmi\u015F hesap",
    created: "Talep: {{date}}",
    completed: "Sonu\xE7: {{date}}",
    blockers: "Silmeyi engelleyenler: {{bookings}} aktif rezervasyon, {{services}} a\xE7\u0131k hizmet talebi",
    noBlockers: "Engel yok; hesap silinebilir.",
    start: "\u0130ncelemeye al",
    complete: "Hesab\u0131 sil",
    reject: "Reddet",
    started: "Talep incelemeye al\u0131nd\u0131.",
    completedToast: "Hesap anonimle\u015Ftirildi.",
    rejectedToast: "Talep reddedildi.",
    rejectTitle: "Talebi reddet",
    rejectHint: "Gerek\xE7e m\xFC\u015Fteriye e-postayla g\xF6nderilir ve hesab\u0131nda g\xF6r\xFCn\xFCr.",
    completeTitle: "Hesap silinsin mi?",
    completeBody: "M\xFC\u015Fterinin ileti\u015Fim bilgileri, profili, adresleri, kay\u0131tl\u0131 yolcular\u0131, favorileri, oturumlar\u0131 ve b\xFClten kayd\u0131 kal\u0131c\u0131 olarak silinir veya anonimle\u015Ftirilir. Rezervasyon, \xF6deme ve fatura kay\u0131tlar\u0131 yasal saklama s\xFCreleri boyunca kal\u0131r. Bu i\u015Flem geri al\u0131namaz.",
    confirmComplete: "Evet, hesab\u0131 sil",
    confirmReject: "Reddet ve bildir",
    retention: {
      title: "Saklama s\xFCreleri",
      hint: "Her gece 03:30'da s\xFCresi dolan ki\u015Fisel veriler otomatik silinir. Rezervasyon, \xF6deme, fatura ve denetim kay\u0131tlar\u0131 yasal saklama s\xFCreleri boyunca tutulur.",
      leadsMonths: "Rezervasyona d\xF6n\xFC\u015Fmeyen talepler: {{count}} ay",
      newsletterPendingDays: "Onaylanmam\u0131\u015F b\xFClten kay\u0131tlar\u0131: {{count}} g\xFCn",
      newsletterUnsubscribedDays: "Abonelikten \xE7\u0131km\u0131\u015F b\xFClten adresleri: {{count}} g\xFCn",
      sessionsDays: "S\xFCresi dolmu\u015F oturumlar ve tek kullan\u0131ml\u0131k kodlar: {{count}} g\xFCn",
      notificationsMonths: "Panel bildirimleri: {{count}} ay"
    }
  },
  reviews: {
    title: "Yorum moderasyonu",
    subtitle: "Tamamlanan rezervasyonlar\u0131n yorumlar\u0131n\u0131 onaylay\u0131n, yan\u0131tlay\u0131n ve ana sayfada \xF6ne \xE7\u0131kar\u0131n.",
    statuses: {
      PENDING: "Bekleyen",
      APPROVED: "Onayl\u0131",
      REJECTED: "Reddedildi"
    },
    rating: "5 \xFCzerinden {{rating}} puan",
    ratingFilter: "Puan",
    search: "Yorum, m\xFC\u015Fteri veya ilan\u2026",
    empty: "Bu filtrelerle yorum yok.",
    moderatedBy: "{{name}} \xB7 {{date}}",
    reply: "Herkese a\xE7\u0131k yan\u0131t",
    replyPlaceholder: "M\xFC\u015Fteriye k\u0131sa bir te\u015Fekk\xFCr veya a\xE7\u0131klama\u2026",
    saveReply: "Yan\u0131t\u0131 kaydet",
    replySaved: "Yan\u0131t kaydedildi.",
    feature: "Ana sayfada referans olarak g\xF6ster",
    featured: "Yorum ana sayfa referanslar\u0131na eklendi.",
    unfeatured: "Yorum referanslardan kald\u0131r\u0131ld\u0131.",
    approve: "Onayla",
    approved: "Yorum onayland\u0131 ve ilan puan\u0131 g\xFCncellendi.",
    reject: "Reddet",
    rejected: "Yorum reddedildi."
  },
  cms: {
    title: "\u0130\xE7erik y\xF6netimi",
    subtitle: "Ana sayfa b\xF6l\xFCmleri, sayfalar, blog, SSS, referanslar, bannerlar, men\xFCler ve medya k\xFCt\xFCphanesi \u2014 d\xF6rt dilde.",
    tabs: {
      home: "Ana sayfa",
      pages: "Sayfalar",
      blog: "Blog",
      journeys: "Rotalar",
      faq: "SSS",
      testimonials: "Referanslar",
      banners: "Bannerlar",
      menus: "Men\xFCler",
      media: "Medya"
    },
    statuses: {
      DRAFT: "Taslak",
      PUBLISHED: "Yay\u0131nda",
      ARCHIVED: "Ar\u015Fivde"
    },
    richHint: "Bi\xE7im: ## Ba\u015Fl\u0131k \xB7 ### Alt ba\u015Fl\u0131k \xB7 - madde \xB7 1. numaral\u0131 \xB7 **kal\u0131n** \xB7 _italik_ \xB7 [ba\u011Flant\u0131](https://\u2026). Paragraflar\u0131 bo\u015F sat\u0131rla ay\u0131r\u0131n.",
    search: "Ba\u015Fl\u0131k veya adres\u2026",
    saved: "Kaydedildi.",
    removed: "Silindi.",
    removeDescription: "Bu kay\u0131t kal\u0131c\u0131 olarak silinecek.",
    viewOnSite: "Sitede g\xF6r\xFCnt\xFCle",
    fields: {
      title: "Ba\u015Fl\u0131k",
      subtitle: "Alt ba\u015Fl\u0131k",
      content: "\u0130\xE7erik",
      status: "Durum",
      type: "T\xFCr",
      updated: "G\xFCncellendi",
      slug: "Adres (slug)",
      sortOrder: "S\u0131ra",
      name: "Ad",
      category: "Kategori",
      published: "Yay\u0131n tarihi",
      excerpt: "\xD6zet",
      tags: "Etiketler",
      cover: "Kapak g\xF6rseli",
      linkUrl: "Ba\u011Flant\u0131",
      linkHint: "Site i\xE7i yol (/blog) veya https:// adresi",
      active: "Aktif",
      inactive: "Pasif"
    },
    seo: {
      heading: "SEO",
      title: "SEO ba\u015Fl\u0131\u011F\u0131",
      titleHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa sayfa ba\u015Fl\u0131\u011F\u0131 kullan\u0131l\u0131r (\u224860 karakter).",
      description: "Meta a\xE7\u0131klama",
      descriptionHint: "Arama sonu\xE7lar\u0131ndaki k\u0131sa a\xE7\u0131klama (\u2248155 karakter).",
      image: "Payla\u015F\u0131m g\xF6rseli (Open Graph)",
      noIndex: "Arama motorlar\u0131nda g\xF6sterme (noindex)"
    },
    media: {
      change: "De\u011Fi\u015Ftir",
      choose: "G\xF6rsel se\xE7",
      remove: "Kald\u0131r",
      pickTitle: "Medya k\xFCt\xFCphanesi",
      pickHint: "Bir g\xF6rsel se\xE7in veya yeni y\xFCkleyin.",
      search: "Dosya ad\u0131\u2026",
      uploaded: "{{count}} dosya y\xFCklendi.",
      upload: "Y\xFCkle",
      empty: "Dosya bulunamad\u0131.",
      url: "Dosya adresi",
      alt: "Alternatif metin",
      altHint: "Eri\u015Filebilirlik ve SEO i\xE7in g\xF6rseli k\u0131saca tarif edin.",
      folder: "Klas\xF6r",
      folderHint: "K\xFC\xE7\xFCk harf, rakam ve tire.",
      usedIn: "{{count}} yerde kullan\u0131l\u0131yor; kullan\u0131mdaki dosya silinemez.",
      unused: "Hi\xE7bir yerde kullan\u0131lm\u0131yor.",
      removeTitle: "Dosya silinsin mi?",
      removeDescription: "Dosya ve t\xFCm boyutlar\u0131 depodan kald\u0131r\u0131lacak.",
      type: "T\xFCr",
      types: {
        IMAGE: "G\xF6rsel",
        VIDEO: "Video",
        DOCUMENT: "Belge"
      },
      usage: "{{count}} kullan\u0131m"
    },
    home: {
      saved: "B\xF6l\xFCm kaydedildi.",
      types: {
        HERO: "Hero (video/g\xF6rsel)",
        CATEGORY_SEARCH: "Kategori arama",
        FEATURED_ASSETS: "\xD6ne \xE7\u0131kan ilanlar",
        EXPERIENCES: "Deneyimler",
        EMPTY_LEGS: "Bo\u015F bacak u\xE7u\u015Flar\u0131",
        WHY_US: "Neden biz",
        TESTIMONIALS: "M\xFC\u015Fteri yorumlar\u0131",
        INSTAGRAM: "Instagram",
        BLOG: "Blog",
        NEWSLETTER: "E-b\xFClten",
        CUSTOM: "\xD6zel i\xE7erik"
      },
      videoUrl: "Video adresi",
      videoHint: "MP4/WebM, sessiz ve d\xF6ng\xFCl\xFC oynat\u0131l\u0131r.",
      posterUrl: "Poster g\xF6rseli adresi",
      categories: "Arama sekmeleri",
      categoriesHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa t\xFCm aktif kategoriler g\xF6sterilir.",
      category: "Kategori",
      anyCategory: "T\xFCm kategoriler",
      limit: "G\xF6sterilecek kay\u0131t",
      limitHint: "1\u201312 aras\u0131.",
      handle: "Instagram kullan\u0131c\u0131 ad\u0131",
      body: "Metin",
      linkLabel: "Ba\u011Flant\u0131 metni",
      empty: "Ana sayfa b\xF6l\xFCm\xFC yok.",
      intro: "B\xF6l\xFCmler ana sayfada bu s\u0131rayla g\xF6r\xFCn\xFCr. Kapal\u0131 b\xF6l\xFCmler gizlenir.",
      visible: "Ana sayfada g\xF6ster",
      moveUp: "Yukar\u0131 ta\u015F\u0131",
      moveDown: "A\u015Fa\u011F\u0131 ta\u015F\u0131"
    },
    pages: {
      new: "Yeni sayfa",
      empty: "Sayfa yok.",
      types: {
        STATIC: "Bilgi sayfas\u0131",
        LEGAL: "Yasal metin",
        LANDING: "Kampanya sayfas\u0131"
      },
      slugHint: "Sitedeki adres: /adres",
      removeTitle: "Sayfa silinsin mi?",
      removeDescription: "Sayfa yay\u0131ndan kalkar ve men\xFClerdeki ba\u011Flant\u0131lar\u0131 kald\u0131r\u0131l\u0131r."
    },
    journeys: {
      new: "Yeni rota",
      empty: "Hen\xFCz rota yok.",
      nights: "{{count}} gece",
      steps: "Ad\u0131m: {{count}}",
      price: "Ba\u015Flang\u0131\xE7 fiyat\u0131",
      priceHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa sitede \u201CFiyat talep \xFCzerine\u201D yazar.",
      nightsLabel: "Gece say\u0131s\u0131",
      location: "B\xF6lge",
      featured: "\xD6ne \xE7\u0131kan rota",
      sortOrder: "S\u0131ra",
      summary: "K\u0131sa \xF6zet",
      description: "Rota hik\xE2yesi",
      highlights: "\xD6ne \xE7\u0131kanlar",
      inclusions: "Dahil olanlar",
      itinerary: "G\xFCn g\xFCn rota",
      items: "Rotadaki ad\u0131mlar",
      itemsHint: "Her ad\u0131m bir ilana, kategoriye veya ekstraya ba\u011Flanabilir; sitede ilan kart\u0131 olarak g\xF6r\xFCn\xFCr.",
      add: "Ekle",
      addDay: "G\xFCn ekle",
      addStep: "Ad\u0131m ekle",
      day: "{{day}}. g\xFCn",
      dayTitle: "Ba\u015Fl\u0131k",
      dayDescription: "A\xE7\u0131klama",
      link: "Ba\u011Flant\u0131",
      links: { NONE: "Ba\u011Flant\u0131 yok", ASSET: "\u0130lan", CATEGORY: "Kategori", ADD_ON: "Ekstra" },
      linkTarget: "Se\xE7im",
      stepDescription: "Ad\u0131m a\xE7\u0131klamas\u0131",
      removeTitle: "Rota siteden kald\u0131r\u0131ls\u0131n m\u0131?",
      removeDescription: "Rota ar\u015Fivlenir; kay\u0131t ve ge\xE7mi\u015Fi saklan\u0131r."
    },
    blog: {
      newCategory: "Yeni kategori",
      categories: "Kategoriler",
      noCategories: "Kategori yok.",
      postCount: "{{count}} yaz\u0131",
      removeCategory: "Kategori silinsin mi?",
      removeCategoryDescription: "Yaz\u0131lar silinmez, kategorisiz kal\u0131r.",
      new: "Yeni yaz\u0131",
      empty: "Blog yaz\u0131s\u0131 yok.",
      excerptHint: "Liste kartlar\u0131nda ve meta a\xE7\u0131klamada kullan\u0131l\u0131r.",
      tagsHint: "Virg\xFClle ay\u0131r\u0131n.",
      readingMinutes: "Okuma s\xFCresi: {{count}} dk",
      removeTitle: "Yaz\u0131 silinsin mi?",
      removeDescription: "Yaz\u0131 yay\u0131ndan kald\u0131r\u0131lacak."
    },
    faq: {
      edit: "Soruyu d\xFCzenle",
      new: "Yeni soru",
      question: "Soru",
      answer: "Cevap",
      group: "Grup",
      groupHint: "Anahtar, \xF6rn. booking, payment, cancellation (sitede dile g\xF6re ba\u015Fl\u0131k olur)",
      general: "Genel",
      empty: "Hen\xFCz soru yok.",
      remove: "Soru silinsin mi?"
    },
    testimonials: {
      edit: "Referans\u0131 d\xFCzenle",
      new: "Yeni referans",
      author: "Ad",
      authorTitle: "Unvan / a\xE7\u0131klama",
      content: "Yorum",
      rating: "Puan",
      featured: "Ana sayfada \xF6ne \xE7\u0131kan",
      fromReview: "M\xFC\u015Fteri yorumundan",
      empty: "Referans yok.",
      remove: "Referans silinsin mi?"
    },
    banners: {
      edit: "Banner\u0131 d\xFCzenle",
      new: "Yeni banner",
      body: "Metin",
      placement: "Konum",
      placements: {
        SITE_TOP: "Site \xFCst\xFC duyuru",
        HOME_HERO: "Ana sayfa hero",
        HOME_INLINE: "Ana sayfa i\xE7i",
        LISTING: "\u0130lan sayfalar\u0131"
      },
      startsAt: "Ba\u015Flang\u0131\xE7",
      endsAt: "Biti\u015F",
      image: "G\xF6rsel",
      empty: "Banner yok.",
      remove: "Banner silinsin mi?"
    },
    menus: {
      label: "Etiket",
      link: "Hedef",
      customUrl: "\xD6zel adres",
      newTab: "Yeni sekmede a\xE7",
      addItem: "\xD6\u011Fe ekle",
      addChild: "Alt \xF6\u011Fe ekle",
      empty: "Bu men\xFCde \xF6\u011Fe yok.",
      intro: "\xDCst men\xFC, alt bilgi ve sosyal ba\u011Flant\u0131lar. Bir \xF6\u011Fe ya bir CMS sayfas\u0131na ya da \xF6zel bir adrese gider."
    }
  },
  templates: {
    title: "Bildirimler & \u015Fablonlar",
    subtitle: "E-posta ve SMS metinlerini d\xF6rt dilde d\xFCzenleyin, \xF6nizleyin; panel bildirimlerini takip edin.",
    mail: "E-posta \u015Fablonlar\u0131",
    smsTab: "SMS \u015Fablonlar\u0131",
    variables: "De\u011Fi\u015Fkenler (eklemek i\xE7in t\u0131klay\u0131n)",
    subject: "Konu",
    body: "\u0130\xE7erik",
    bodyHint: "Paragraflar\u0131 bo\u015F sat\u0131rla ay\u0131r\u0131n. a\u015Fa\u011F\u0131daki de\u011Fi\u015Fkenler g\xF6nderimde doldurulur; butonlar ve rezervasyon \xF6zeti otomatik eklenir.",
    useCustom: "Panel metnini kullan (kapal\u0131ysa yerle\u015Fik metin g\xF6nderilir)",
    preview: "\xD6nizle",
    previewSubject: "Konu",
    resetTitle: "Varsay\u0131lana d\xF6n\xFCls\xFCn m\xFC?",
    resetDescription: "Bu dil i\xE7in paneldeki de\u011Fi\u015Fiklikler silinir ve yerle\u015Fik metin kullan\u0131l\u0131r.",
    reset: "Varsay\u0131lana d\xF6n",
    resetDone: "Varsay\u0131lan metne d\xF6n\xFCld\xFC.",
    saved: "\u015Eablon kaydedildi.",
    customized: "\xD6zelle\u015Ftirildi",
    default: "Varsay\u0131lan",
    smsIntro: "Onay, hat\u0131rlatma, \xF6deme linki ve teklif SMS'leri. G\xF6nderim Ayarlar \u203A Bildirimler b\xF6l\xFCm\xFCnden a\xE7\u0131l\u0131r.",
    smsLength: "{{count}} / {{max}} karakter",
    groups: {
      account: "Hesap",
      bookings: "Rezervasyon & \xF6deme",
      services: "Sahip hizmetleri",
      trips: "Seyahat planlar\u0131",
      operations: "Operasyon"
    },
    keys: {
      "verify-email": "E-posta do\u011Frulama",
      "reset-password": "\u015Eifre s\u0131f\u0131rlama",
      "newsletter-confirm": "E-b\xFClten onay\u0131",
      "admin-invite": "Panel kullan\u0131c\u0131 daveti",
      "data-deletion-completed": "Ki\u015Fisel veri: hesap silindi",
      "data-request-rejected": "Ki\u015Fisel veri: talep reddedildi",
      "booking-awaiting": "Rezervasyon onay bekliyor",
      "booking-confirmed": "Rezervasyon onayland\u0131",
      "booking-rescheduled": "Rezervasyon tarihi de\u011Fi\u015Fti",
      "booking-reminder": "Rezervasyon hat\u0131rlatmas\u0131",
      "booking-cancelled": "Rezervasyon iptal edildi",
      "booking-cancellation-requested": "\u0130ptal talebi al\u0131nd\u0131",
      "payment-received": "\xD6deme al\u0131nd\u0131",
      "payment-refunded": "\u0130ade yap\u0131ld\u0131",
      "balance-reminder": "Bakiye hat\u0131rlatmas\u0131",
      "balance-overdue": "Bakiye gecikti",
      "payment-link": "\xD6deme linki",
      "invoice-sent": "Fatura g\xF6nderildi",
      "review-request": "Yorum iste\u011Fi",
      "service-request-received": "Hizmet talebi al\u0131nd\u0131",
      "quote-sent": "Teklif g\xF6nderildi",
      "quote-accepted": "Teklif onayland\u0131",
      "service-scheduled": "Hizmet planland\u0131",
      "service-completed": "Hizmet tamamland\u0131",
      "service-payment-received": "Hizmet \xF6demesi al\u0131nd\u0131",
      "service-request-cancelled": "Hizmet talebi iptal edildi",
      "ops-alert": "Operasyon uyar\u0131s\u0131",
      "staff-documents-expiring": "Personel belgeleri dolmak \xFCzere",
      "scheduled-report": "Zamanlanm\u0131\u015F rapor",
      "trip-plan-received": "Seyahat plan\u0131 al\u0131nd\u0131",
      "trip-plan-paid": "Seyahat plan\u0131 \xF6demesi",
      "trip-plan-confirmed": "Seyahat onayland\u0131",
      "trip-plan-cancelled": "Seyahat plan\u0131 iptal edildi"
    },
    sms: {
      "booking-confirmed": "Rezervasyon onay\u0131",
      "booking-reminder": "Rezervasyon hat\u0131rlatmas\u0131",
      "payment-link": "\xD6deme linki",
      "quote-sent": "Teklif g\xF6nderildi"
    }
  },
  notificationCenter: {
    title: "Bildirim merkezi",
    open: "A\xE7",
    bell: "Bildirimler \xB7 {{badge}} okunmam\u0131\u015F",
    markAll: "T\xFCm\xFCn\xFC okundu say",
    empty: "Bildirim yok.",
    viewAll: "T\xFCm bildirimler",
    unreadOnly: "Yaln\u0131zca okunmam\u0131\u015Flar",
    markRead: "Okundu say",
    events: {
      booking: {
        created: "Yeni rezervasyon {{code}} \xB7 {{customer}}",
        cancellationRequested: "\u0130ptal talebi {{code}} \xB7 {{customer}}"
      },
      serviceRequest: {
        created: "Yeni hizmet talebi {{code}} \xB7 {{customer}}"
      },
      quote: {
        accepted: "Teklif onayland\u0131 {{code}} \xB7 {{customer}}",
        rejected: "Teklif reddedildi {{code}} \xB7 {{customer}}"
      },
      lead: {
        created: "Yeni talep \xB7 {{name}}"
      },
      payment: {
        received: "\xD6deme al\u0131nd\u0131 {{amount}} \xB7 {{reference}}"
      },
      review: {
        submitted: "Yeni yorum ({{rating}}\u2605) \xB7 {{listing}}"
      },
      dataRequest: {
        created: "Hesap silme talebi (KVKK) \xB7 {{customer}}"
      },
      tripPlan: {
        depositPaid: "Yeni seyahat plan\u0131 {{code}} \xB7 {{customer}} \xB7 kapora {{amount}}"
      }
    }
  },
  users: {
    title: "Kullan\u0131c\u0131lar & roller",
    subtitle: "Panel kullan\u0131c\u0131lar\u0131n\u0131 davet edin, rollerini ve oturumlar\u0131n\u0131 y\xF6netin; rol yetkilerini d\xFCzenleyin.",
    tabs: {
      users: "Kullan\u0131c\u0131lar",
      roles: "Roller & yetkiler"
    },
    search: "Ad veya e-posta\u2026",
    invite: "Kullan\u0131c\u0131 davet et",
    inviteHint: "Ki\u015Fi e-postadaki ba\u011Flant\u0131yla \u015Fifresini belirler, ilk giri\u015Fte iki ad\u0131ml\u0131 do\u011Frulamay\u0131 kurar.",
    invited: "Davet {{email}} adresine g\xF6nderildi.",
    sendInvite: "Davet g\xF6nder",
    form: {
      firstName: "Ad",
      lastName: "Soyad",
      email: "E-posta",
      phone: "Telefon",
      roles: "Roller",
      status: "Durum"
    },
    statuses: {
      ACTIVE: "Aktif",
      SUSPENDED: "Ask\u0131da"
    },
    lastLogin: "Son giri\u015F: {{date}}",
    saved: "Kullan\u0131c\u0131 g\xFCncellendi.",
    linkSent: "Ba\u011Flant\u0131 e-postayla g\xF6nderildi.",
    resendInvite: "Daveti yeniden g\xF6nder",
    sendPasswordLink: "\u015Eifre ba\u011Flant\u0131s\u0131 g\xF6nder",
    resetTwoFactorTitle: "\u0130ki ad\u0131ml\u0131 do\u011Frulama s\u0131f\u0131rlans\u0131n m\u0131?",
    resetTwoFactorDescription: "Kullan\u0131c\u0131n\u0131n t\xFCm oturumlar\u0131 kapan\u0131r; bir sonraki giri\u015Fte 2FA'y\u0131 yeniden kurar.",
    resetTwoFactor: "2FA s\u0131f\u0131rla",
    twoFactorReset: "2FA s\u0131f\u0131rland\u0131.",
    sessions: "A\xE7\u0131k oturumlar",
    noSessions: "A\xE7\u0131k oturum yok.",
    unknownDevice: "Bilinmeyen cihaz",
    thisSession: "Bu oturum",
    sessionStarted: "ba\u015Flad\u0131 {{date}}",
    sessionUsed: "son kullan\u0131m {{date}}",
    sessionRevoked: "Oturum kapat\u0131ld\u0131.",
    revoke: "Kapat",
    logins: "Giri\u015F ge\xE7mi\u015Fi",
    noLogins: "Kay\u0131t yok.",
    empty: "Kullan\u0131c\u0131 bulunamad\u0131.",
    columns: {
      user: "Kullan\u0131c\u0131",
      security: "G\xFCvenlik",
      lastLogin: "Son giri\u015F"
    },
    pendingInvite: "Davet bekliyor",
    noTwoFactor: "2FA yok",
    roleUsers: "\xB7 {{count}} kullan\u0131c\u0131",
    removeRoleTitle: "Rol silinsin mi?",
    removeRoleDescription: "Yaln\u0131zca kullan\u0131c\u0131s\u0131 olmayan \xF6zel roller silinebilir.",
    roleRemoved: "Rol silindi.",
    permissionsSaved: "Yetkiler kaydedildi.",
    superAdminNote: "S\xFCper Admin her zaman t\xFCm yetkilere sahiptir; d\xFCzenlenemez.",
    modules: {
      dashboard: "G\xF6sterge paneli",
      bookings: "Rezervasyonlar",
      calendar: "Takvim",
      assets: "\u0130lanlar",
      categories: "Kategoriler",
      pricing: "Fiyatland\u0131rma",
      availability: "M\xFCsaitlik",
      campaigns: "Kampanyalar",
      customers: "M\xFC\u015Fteriler",
      privacy: "KVKK talepleri",
      leads: "Talepler",
      serviceRequests: "Hizmet talepleri",
      tripPlans: "Seyahat planlar\u0131",
      quotes: "Teklifler",
      workOrders: "\u0130\u015F emirleri",
      staff: "Personel",
      finance: "Finans",
      payments: "\xD6demeler",
      expenses: "Giderler",
      invoices: "Faturalar",
      cms: "\u0130\xE7erik",
      media: "Medya",
      reviews: "Yorumlar",
      notifications: "Bildirimler",
      reports: "Raporlar",
      settings: "Ayarlar",
      featureFlags: "\xD6zellik bayraklar\u0131",
      users: "Kullan\u0131c\u0131lar",
      roles: "Roller",
      audit: "Denetim kayd\u0131"
    },
    actions: {
      read: "G\xF6r\xFCnt\xFCle",
      create: "Olu\u015Ftur",
      update: "D\xFCzenle",
      cancel: "\u0130ptal et",
      export: "D\u0131\u015Fa aktar",
      manage: "Y\xF6net",
      publish: "Yay\u0131nla",
      archive: "Ar\u015Fivle",
      send: "G\xF6nder",
      refund: "\u0130ade et",
      moderate: "Moderasyon",
      view: "G\xF6r\xFCnt\xFCle"
    },
    newRole: "Yeni rol",
    roleCreated: "Rol olu\u015Fturuldu.",
    roleName: "Rol ad\u0131",
    roleDescription: "A\xE7\u0131klama",
    copyFrom: "Yetkileri kopyala",
    emptyRole: "Bo\u015F ba\u015Fla"
  },
  audit: {
    title: "Denetim kayd\u0131",
    subtitle: "Kritik i\u015Flemlerin kim taraf\u0131ndan, ne zaman ve hangi de\u011Ferlerle yap\u0131ld\u0131\u011F\u0131 (de\u011Fi\u015Ftirilemez kay\u0131t).",
    action: "\u0130\u015Flem (\xF6rn. booking.)",
    entity: "Kay\u0131t t\xFCr\xFC (\xF6rn. Booking)",
    empty: "Kay\u0131t bulunamad\u0131.",
    before: "\xD6nce",
    after: "Sonra",
    meta: "Ek bilgi",
    actors: {
      ADMIN: "Y\xF6netici",
      CUSTOMER: "M\xFC\u015Fteri",
      SYSTEM: "Sistem"
    }
  },
  settings: {
    title: "Ayarlar",
    subtitle: "\u015Eirket, finans, rezervasyon, \xF6deme, bildirim, rapor, SEO ve entegrasyon ayarlar\u0131. Her de\u011Fi\u015Fiklik denetim kayd\u0131na yaz\u0131l\u0131r.",
    groups: {
      general: "Genel",
      company: "\u015Eirket",
      finance: "Finans",
      booking: "Rezervasyon",
      payments: "\xD6deme",
      services: "Teklifler",
      notifications: "Bildirimler",
      reports: "Raporlar",
      seo: "SEO",
      integrations: "Entegrasyonlar & \xE7erezler",
      flags: "\xD6zellik bayraklar\u0131",
      system: "Sistem durumu"
    },
    updated: "Son de\u011Fi\u015Fiklik: {{date}} \xB7 {{name}}",
    defaultValue: "Varsay\u0131lan de\u011Fer kullan\u0131l\u0131yor",
    public: "web sitesinde kullan\u0131l\u0131r",
    saved: "Ayar kaydedildi.",
    flagsHint: "Mod\xFClleri kod de\u011Fi\u015Fikli\u011Fi olmadan a\xE7\u0131p kapat\u0131n.",
    systemHint: "Ortam de\u011Fi\u015Fkenlerinden gelen canl\u0131 yap\u0131land\u0131rma.",
    gateway: "\xD6deme altyap\u0131s\u0131",
    providers: "Sa\u011Flay\u0131c\u0131lar",
    emailProvider: "E-posta",
    smsProvider: "SMS",
    secretsNote: "API anahtarlar\u0131 ve \u015Fifreler bu ekranda tutulmaz; sunucu ortam de\u011Fi\u015Fkenlerinde saklan\u0131r.",
    fields: {
      name: "Marka ad\u0131",
      legalName: "Ticari unvan",
      phone: "Telefon",
      whatsapp: "WhatsApp",
      email: "E-posta",
      logoUrl: "Logo adresi",
      logoHint: "Bo\u015F b\u0131rak\u0131l\u0131rsa yerle\u015Fik logo kullan\u0131l\u0131r.",
      address: "Adres",
      taxOffice: "Vergi dairesi",
      taxNumber: "Vergi no",
      mersisNo: "MERS\u0130S no",
      vatStandard: "Genel oran",
      vatReduced: "\u0130ndirimli oran",
      vatAccommodation: "Konaklama",
      deposit: "Kapora",
      days: "G\xFCn",
      minutes: "Dakika",
      terms: "\u015Eartlar",
      defaultLocale: "Varsay\u0131lan dil",
      defaultCurrency: "Varsay\u0131lan para birimi",
      locales: "Aktif diller",
      currencies: "Para birimleri",
      timezone: "Saat dilimi",
      titleTemplate: "Ba\u015Fl\u0131k \u015Fablonu",
      titleTemplateHint: "%s sayfa ba\u015Fl\u0131\u011F\u0131yla de\u011Fi\u015Ftirilir, \xF6rn. %s \xB7 DuvaMarine",
      description: "Varsay\u0131lan a\xE7\u0131klama",
      pixelHint: "Yaln\u0131zca rakamlar",
      bannerEnabled: "\xC7erez band\u0131n\u0131 g\xF6ster",
      cookieAnalytics: "Analitik \xE7erez se\xE7ene\u011Fi",
      cookieMarketing: "Pazarlama \xE7erez se\xE7ene\u011Fi",
      policyVersion: "Politika s\xFCr\xFCm\xFC",
      policyVersionHint: "De\u011Fi\u015Ftirildi\u011Finde ziyaret\xE7ilere yeniden sorulur.",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      youtube: "YouTube",
      providerEnabled: "Etkin",
      providerMode: "Mod",
      modeTest: "Test",
      modeLive: "Canl\u0131",
      operationsEmails: "Operasyon e-postalar\u0131",
      emailsHint: "Virg\xFClle ay\u0131r\u0131n (en fazla 10).",
      reminderHours: "Rezervasyon hat\u0131rlatmas\u0131 (saat \xF6nce)",
      reviewDelay: "Yorum iste\u011Fi (tamamland\u0131ktan g\xFCn sonra)",
      zeroOff: "0 = kapal\u0131",
      smsEnabled: "SMS kopyalar\u0131n\u0131 g\xF6nder",
      scheduleEnabled: "Zamanlanm\u0131\u015F e-postay\u0131 g\xF6nder",
      frequency: "S\u0131kl\u0131k",
      recipients: "Al\u0131c\u0131lar",
      reports: "Raporlar"
    },
    keys: {
      company: {
        profile: {
          title: "\u015Eirket profili",
          hint: "Sitede, e-postalarda ve belgelerde g\xF6r\xFCnen ileti\u015Fim bilgileri."
        },
        tax: {
          title: "Vergi bilgileri",
          hint: "Fatura ve tekliflerde kullan\u0131l\u0131r."
        }
      },
      finance: {
        vat_rates_bps: {
          title: "KDV oranlar\u0131",
          hint: "Varsay\u0131lan KDV oranlar\u0131 (fiyatlar KDV dahil girilir)."
        },
        default_deposit_bps: {
          title: "Varsay\u0131lan kapora oran\u0131",
          hint: "Kategori/politika belirtmedi\u011Finde al\u0131nan \xF6n \xF6deme y\xFCzdesi."
        },
        trip_plan_deposit_bps: {
          title: "Seyahat plan\u0131 kapora oran\u0131",
          hint: "Yeni seyahat planlar\u0131nda al\u0131nan kapora y\xFCzdesi (en az %1). G\xF6nderilmi\u015F planlar etkilenmez."
        },
        balance_due_days_before_start: {
          title: "Bakiye vadesi",
          hint: "Kalan bakiye ba\u015Flang\u0131\xE7tan ka\xE7 g\xFCn \xF6nce \xF6denmeli."
        }
      },
      booking: {
        hold_minutes: {
          title: "Sepet tutma s\xFCresi",
          hint: "\xD6deme s\u0131ras\u0131nda tarihin kilitli tutuldu\u011Fu s\xFCre (dakika)."
        }
      },
      localization: {
        title: "Dil ve para birimi",
        hint: "Varsay\u0131lan dil, aktif diller, para birimleri ve saat dilimi."
      },
      seo: {
        defaults: {
          title: "SEO varsay\u0131lanlar\u0131",
          hint: "Ba\u015Fl\u0131k \u015Fablonu ve varsay\u0131lan meta a\xE7\u0131klama."
        }
      },
      analytics: {
        title: "Analitik",
        hint: "Kimlikler yaln\u0131zca ziyaret\xE7i \xE7erez onay\u0131 verdikten sonra y\xFCklenir."
      },
      cookies: {
        title: "\xC7erez band\u0131",
        hint: "KVKK/GDPR \xE7erez onay\u0131; s\xFCr\xFCm de\u011Fi\u015Fince herkese yeniden sorulur."
      },
      social: {
        title: "Sosyal medya",
        hint: "Alt bilgide ve payla\u015F\u0131m kartlar\u0131nda kullan\u0131l\u0131r."
      },
      payments: {
        providers: {
          title: "\xD6deme sa\u011Flay\u0131c\u0131lar\u0131",
          hint: "Hangi sa\u011Flay\u0131c\u0131n\u0131n hangi modda kullan\u0131laca\u011F\u0131 (anahtarlar ortam de\u011Fi\u015Fkenlerindedir)."
        }
      },
      quotes: {
        validity_days: {
          title: "Teklif ge\xE7erlilik s\xFCresi",
          hint: "Yeni tekliflerin varsay\u0131lan ge\xE7erlilik g\xFCn\xFC."
        },
        default_terms: {
          title: "Varsay\u0131lan teklif \u015Fartlar\u0131",
          hint: "Yeni tekliflere eklenen \u015Fartlar metni."
        }
      },
      notifications: {
        title: "Bildirim ayarlar\u0131",
        hint: "Operasyon al\u0131c\u0131lar\u0131, otomatik hat\u0131rlatma ve yorum iste\u011Fi zamanlamas\u0131, SMS."
      },
      reports: {
        schedule: {
          title: "Zamanlanm\u0131\u015F rapor e-postas\u0131",
          hint: "Haftal\u0131k (pazartesi 08:00) veya ayl\u0131k (ay\u0131n 1'i 08:00) Excel ekli \xF6zet."
        }
      }
    }
  },
  setPassword: {
    title: "\u015Eifrenizi belirleyin",
    subtitle: "Y\xF6netim paneli hesab\u0131n\u0131z i\xE7in bir \u015Fifre olu\u015Fturun; ard\u0131ndan iki ad\u0131ml\u0131 do\u011Frulamay\u0131 kuracaks\u0131n\u0131z.",
    invalid: "Ba\u011Flant\u0131 eksik ya da ge\xE7ersiz. Y\xF6neticinizden yeni bir ba\u011Flant\u0131 isteyin.",
    password: "Yeni \u015Fifre",
    hint: "En az 10 karakter; en az bir harf ve bir rakam.",
    confirm: "\u015Eifre (tekrar)",
    submit: "\u015Eifreyi kaydet",
    done: "\u015Eifreniz kaydedildi. \u015Eimdi giri\u015F yapabilirsiniz."
  }
};

// src/locales/tr/documents.ts
var documents = {
  voucher: {
    title: "Rezervasyon Belgesi",
    code: "Rezervasyon kodu",
    status: "Durum",
    listing: "Rezervasyon",
    period: "Tarih ve saat",
    location: "Bulu\u015Fma noktas\u0131",
    route: "G\xFCzerg\xE2h",
    guests: "Ki\u015Fi say\u0131s\u0131",
    guest: "Misafir",
    travellers: "Yolcular",
    extras: "Ekstralar",
    special: "\xD6zel istekler",
    payment: "\xD6deme \xF6zeti",
    total: "Toplam (KDV dahil)",
    paid: "\xD6denen",
    balance: "Kalan bakiye",
    balanceDue: "Son \xF6deme: {{date}}",
    policy: "\u0130ptal politikas\u0131",
    refundBefore: "Ba\u015Flang\u0131\xE7tan {{hours}} saat \xF6ncesine kadar: %{{percent}} iade",
    concierge: "7/24 dan\u0131\u015Fman hatt\u0131",
    note: "L\xFCtfen bu belgeyi hizmet ba\u015Flang\u0131c\u0131nda dijital veya bas\u0131l\u0131 olarak ibraz edin. Kare kod rezervasyon kodunuzu i\xE7erir.",
    issued: "D\xFCzenlenme: {{date}}",
    refundLast: "Sonras\u0131nda: %{{percent}} iade"
  },
  calendar: {
    summary: "DuvaMarine \xB7 {{listing}}",
    description: "Rezervasyon kodu: {{code}} \xB7 Rezervasyonu g\xF6r\xFCnt\xFCle: {{url}}"
  },
  invoice: {
    title: "Fatura",
    creditNote: "\u0130ade Faturas\u0131",
    proforma: "Proforma Fatura",
    number: "Fatura no",
    date: "D\xFCzenleme tarihi",
    dueDate: "Son \xF6deme",
    seller: "Sat\u0131c\u0131",
    buyer: "Al\u0131c\u0131",
    taxOffice: "Vergi dairesi",
    taxNumber: "VKN/TCKN",
    booking: "Rezervasyon",
    credits: "\u0130lgili fatura",
    description: "A\xE7\u0131klama",
    quantity: "Miktar",
    unitPrice: "Birim fiyat",
    vat: "KDV",
    net: "Tutar",
    subtotal: "Ara toplam",
    vatLine: "KDV %{{rate}}",
    total: "Genel toplam",
    notes: "Notlar",
    infoCopy: "Bu belge bilgi ama\xE7l\u0131d\u0131r; resm\xEE e-Ar\u015Fiv faturan\u0131z entegrat\xF6r taraf\u0131ndan ayr\u0131ca iletilir.",
    eArchive: "e-Ar\u015Fiv ETTN: {{uuid}}",
    cancelled: "\u0130PTAL",
    discount: "\u0130ndirim ({{code}})",
    rental: "{{listing}} \xB7 {{period}}",
    tripPlan: "Seyahat plan\u0131",
    tripPlanLine: "\xD6zel seyahat plan\u0131 {{code}} \xB7 {{period}}"
  },
  quote: {
    title: "Teklif",
    date: "Tarih",
    validUntil: "Ge\xE7erlilik",
    request: "Talep",
    revision: "Revizyon",
    from: "Teklifi veren",
    customer: "M\xFC\u015Fteri",
    service: "Hizmet",
    asset: "Varl\u0131k",
    discountColumn: "\u0130nd.",
    discountTotal: "\u0130ndirim",
    deposit: "\xD6n \xF6deme (%{{percent}})",
    terms: "Ko\u015Fullar",
    approve: "Bu teklifi {{url}} adresinden online onaylayabilirsiniz.",
    footer: "Fiyatlar aksi belirtilmedik\xE7e KDV hari\xE7tir; KDV ayr\u0131ca g\xF6sterilmi\u015Ftir.",
    lineDiscount: "\u0130ndirim %{{percent}} \xB7 {{description}}",
    types: {
      LABOR: "\u0130\u015F\xE7ilik",
      MATERIAL: "Malzeme",
      SERVICE: "Hizmet",
      FEE: "\xDCcret",
      DISCOUNT: "\u0130ndirim"
    },
    stamps: {
      ACCEPTED: "ONAYLANDI",
      REJECTED: "REDDED\u0130LD\u0130",
      EXPIRED: "S\xDCRES\u0130 DOLDU",
      CANCELLED: "\u0130PTAL",
      SUPERSEDED: "YEN\u0130LEND\u0130"
    }
  },
  exports: {
    generatedAt: "Olu\u015Fturulma: {{date}}",
    period: "D\xF6nem: {{from}} \u2013 {{to}}",
    totals: "Toplam",
    titles: {
      ledger: "Hesap defteri",
      payments: "Tahsilatlar",
      refunds: "\u0130adeler",
      receivables: "Alacaklar",
      expenses: "Giderler",
      invoices: "Faturalar",
      "cash-flow": "Nakit ak\u0131\u015F\u0131",
      profitability: "K\xE2rl\u0131l\u0131k",
      bookings: "Rezervasyonlar"
    },
    columns: {
      date: "Tarih",
      account: "Hesap",
      type: "T\xFCr",
      direction: "Y\xF6n",
      amount: "Tutar",
      currency: "Para birimi",
      amountTry: "TRY kar\u015F\u0131l\u0131\u011F\u0131",
      description: "A\xE7\u0131klama",
      booking: "Rezervasyon",
      listing: "\u0130lan",
      code: "Kod",
      customer: "M\xFC\u015Fteri",
      kind: "\xD6deme t\xFCr\xFC",
      method: "Y\xF6ntem",
      provider: "Sa\u011Flay\u0131c\u0131",
      status: "Durum",
      refunded: "\u0130ade edilen",
      reason: "Neden",
      total: "Toplam",
      paid: "\xD6denen",
      balance: "Kalan",
      dueDate: "Vade",
      overdueDays: "Gecikme (g\xFCn)",
      category: "Kategori",
      vendor: "Tedarik\xE7i",
      vat: "KDV",
      number: "Fatura no",
      billingName: "Fatura ad\u0131",
      period: "D\xF6nem",
      inflow: "Giri\u015F",
      outflow: "\xC7\u0131k\u0131\u015F",
      net: "Net",
      revenue: "Gelir",
      refunds: "\u0130adeler",
      expenses: "Giderler",
      margin: "Marj",
      bookings: "Rezervasyon",
      source: "Kaynak",
      email: "E-posta",
      start: "Ba\u015Flang\u0131\xE7",
      end: "Biti\u015F",
      created: "Olu\u015Fturma"
    }
  }
};

export {
  admin,
  documents
};
//# sourceMappingURL=chunk-MC2WDLJQ.js.map